


class PostalCodeValidator {
    constructor(baseUrl, inputSelector, hintSelector) {
        this.baseUrl = baseUrl;
        this.inputElement = document.querySelector(inputSelector);
        this.buttonElement = document.querySelector(".btn_group .btn__cta.btnn");
        this.buttonElementSubmit = this.inputElement.closest('.info_cont').querySelector(".submit-postal");
        this.hintElement = document.querySelector(hintSelector);
        this.postalCodes = localStorage.getItem('zones');
        this.initialize();
        // localStorage.setItem("postal_code", "");
        // localStorage.removeItem("currentDate");
        // localStorage.removeItem("currentDay");
        // localStorage.removeItem("cartJSON");
    }

    initialize() {
        this.inputElement.addEventListener('keypress', this.handleKeyPress.bind(this));
        this.buttonElementSubmit.addEventListener('click', this.validatePostalCode.bind(this));
        this.buttonElement.addEventListener('click', this.handleClick.bind(this));
    }

    handleKeyPress(event) {
        if (event.keyCode === 13) {
            this.validatePostalCode(event.target.value);
        }
    }

    handleClick(){
        this.validatePostalCode(document.querySelector(".vl-postalcode").value);
    }

    removeEmptyRecords() {
        this.postalCodes = localStorage.getItem('zones');
        let array = this.postalCodes.toString().toLocaleLowerCase().replace(/"/ig, "").split(",")
        return array.filter(item => item !== null && item !== undefined && item.toString().trim() !== "");
    }

    isPrefixMatched(postalCode) {
        let arr = this.removeEmptyRecords();
        for (let prefix of arr) {
            if (postalCode.toLocaleLowerCase().startsWith(prefix)) {
                return true;
            }
        }
        return false;
    }

    async validatePostalCode(postalCode) {
        var post_val = postalCode;
        if(postalCode.type != null && postalCode.type == 'click'){
            post_val = this.inputElement.value;
        }
        try {
            // const response = await fetch(`${this.baseUrl}/check/postal-code?code=${postalCode}`);
            // const data = await response.json();
            let status = this.isPrefixMatched(post_val);
            this.handleValidationResult(status, this.inputElement, post_val);
        } catch (error) {
            console.error('Error:', error);
        }
    }

  // # New Mike Code to auto-direct user after sucessful postal code //
  
    handleValidationResult(status, element, postalCode) {
        var button = element.closest('.field').querySelector('.hero_cta_container') || null;
        var button_has_disabled = button != null && button.classList.contains('disabled');        
        if (status === false) {
            // Invalid postal code - keep existing error UI
            element.classList.add('error');
            document.querySelector(".vl__success--msg.msg").classList.add("hide");
            if(postalCode != ''){
                document.querySelector(".vl__error--msg.msg").classList.remove("hide");
            }
            document.querySelector(".sticky-build-plan").classList.add("hide");

            document.querySelector(".btn_group.btn--orange.success").classList.add("hide");
            document.querySelector(".btn_group.btn--text-group.fail").classList.remove("hide");
        } else {
            // Valid postal code - show success UI briefly before redirect            
            element.classList.remove('error');
            
            document.querySelector(".vl__error--msg.msg").classList.add("hide");
            if( button_has_disabled ){
                document.querySelector(".vl__error--weekDate.msg").classList.remove("hide");
                document.querySelector(".vl__success--msg.msg").classList.add("has_eligible");
            }else{
                
                element.closest('.field') && element.closest('.field').querySelector('.hero_cta_container').classList.add('hide');
                document.querySelector(".vl__success--msg.msg").classList.remove("hide");    
                            
                var plan = document.querySelector(".sticky-build-plan");
                plan.classList.add("sticky_enable");
                plan.querySelector(".sticky-plan__info > p").textContent = 'Delivery to: ' + postalCode;
                //this.buttonElement.parentElement.classList.add("hide");
                localStorage.setItem("postal_code", postalCode);            
                //document.querySelector(".btn_group.btn--orange.success").classList.remove("hide");
                document.querySelector(".btn_group.btn--text-group.fail").classList.add("hide");
                setTimeout(() => {
                    if(document.querySelector('.tab-button.active').textContent.indexOf("LIMITED -") > -1){
                        window.location.href = "/pages/limited-menu";
                    }else{
                        window.location.href = "/pages/otr-meals#menu-builder-section";
                    }
                }, 500); // 0.5 second delay
            }
            // Add short delay before redirect to show success message
            
        }
    }
}

class MenuProduct {
    constructor(id, collection, title, price, image, sku, tags) {
        this.id = id;
        this.collection = collection;
        this.title = title;
        this.price = price;
        this.image = image;
        this.sku = sku;
        this.tags = tags;
    }

    generateHTML(index) {        
        return `
            <div class="meal meal${index + 1}">
                <div class="meal__item-inner">
                    <div class="meal_img_cont">
                        <img src="${this.image}" alt="${this.title}">
                        <div class="media-content">          
                            <div class="discounted-label-variants">
                                <ul class="discounted-label">
                                    <li class="card--label card--label-save"><span style="background: #FA935A;">Save 10%</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="meal_info_cont">
                        <div class="meal_naming">
                            <div class="meal_rating">
                                <div class="yotpo bottomLine" data-product-id="${this.id}"></div>
                            </div>
                            <h2 class="meal_h2">${this.title}</h2>
                        </div>
                        <div class="meal_price">
                            <p class="meal_current_price">$${this.price}</p>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

class MenuTab {
    constructor(name, products) {
        this.name = name;
        this.products = products.map((product, index) => new MenuProduct(
            product.id,
            product.collection,
            product.title,
            product.price,
            product.image,
            product.sku,
            product.tags
        ));
    }

    generateTabControlHTML(index) {
        return `
            <input type="radio" name="tabset" id="tab${index + 1}" aria-controls="tab-panel-${index + 1}" ${index === 0 ? 'checked' : ''}>
            <label for="tab${index + 1}">${this.name}</label>
        `;
    }

    generateTabPanelHTML(index) {
        const productsHTML = this.products.map((product, productIndex) => product.generateHTML(productIndex)).join('');
        return `
            <section id="tab-panel-${index + 1}" class="tab-panel">
                <div class="meals_cont">
                    ${productsHTML}
                </div>
            </section>
        `;
    }
}

class MenuTabManager {
    constructor(data) {
        this.tabs = data.tabs.map((tabName) => {
            const tabProducts = data.products.filter(product => product.collection === tabName);
            return new MenuTab(tabName, tabProducts);
        });
    }

    generateHTML() {
        let tabControlsHTML = '';
        let tabPanelsHTML = '';

        this.tabs.forEach((tab, index) => {
            tabControlsHTML += tab.generateTabControlHTML(index);
            tabPanelsHTML += tab.generateTabPanelHTML(index);
            if( index == (tabArray.length - 1) ){
                callYotpo();
            }
        });

        return `
            ${tabControlsHTML}
            <div class="tab-panels">
                ${tabPanelsHTML}
            </div>
        `;
    }

    render(selector) {
        document.querySelector(selector).innerHTML = this.generateHTML();
    }
}

class WeeklyProduct {
    constructor(apiUrl, selector) {
        this.apiUrl = apiUrl;
        this.selector = selector;
    }

    fetchAndRender() {
        fetch(this.apiUrl)
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                    const tabManager = new MenuTabManager(data.data);
                    tabManager.render(this.selector);
                } else {
                    console.error('Failed to fetch data:', data);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }
}

class ScheduleRenderer {
    constructor(data) {
        this.data = data;
        this.container = document.querySelector('.selector_buttons_cont');
        this.deliveryInfo = document.querySelector('.step1_foot h1 span');
        this.headingContainer = document.querySelector('.step2_heading_cont > p span');
        this.categoryContainer = document.querySelector('.food_catagory_btns_cont');
        this.mealsContainer = document.querySelector('.meal_selection');
        this.filterButton = this.categoryContainer.querySelector('.food_catagory_btns.filter');        
        this.addToCartButtons = this.mealsContainer.querySelectorAll(".unselected.meal_selection_price");
        this.orderSummary = document.querySelector(".order_summary_cont");        
        this.deliveryWindowInner = document.querySelector(".delivery-schedule-inner.slideout-sec__inner.delivery-schedule__inner");

        this.currentDate = this.data[0].start_date;
        this.currentDay = this.data[0].delivery_days[0];
        this.fullDate = this.formatedStartEndDates(this.data[0].start_date, this.data[0].end_date);
        this.startDate = this.data[0].start_date;
        this.endDate = this.data[0].end_date;
        this.maxDeliveries = this.data[0].max_deliveries;
        this.validDays = this.data[0].delivery_days;
        this.isClickEventBind = false;       
        this.firstDay = this.currentDay; 
        this.dayWiseTimeSlots = this.data[0]['daywise_timeslots'];
        this.currentZone = '';
        this.subscriptionDiscount = 15;
        this.sellingPlans = {};
        this.isSingleDay = true;
        this.tiers = [];
        this.deliveryNote = "Leave at the front door";
        this.freeGiftPromo = this.data[0]['freeGiftPromotion'];
        this.perDiscountPromo = this.data[0]['percentOffPromotion'];
        this.isFreeProductAdded = false;
        this.isFreeProductAddedOld = false;
        this.promoDiscountAmount = 0.00;
        this.dayKeys = ['counter', 'meals_total', 'order_total', 'order_saving', 'order_tax'];
        this.getZone();

        this.cartJson = this.getCartObject();   
        this.isDaysChanged();     
        this.is_saving = true;
        if(document.querySelector('body.limited-menu')){
            this.is_saving = false;
        }

        var has_week_date = localStorage.getItem('weekDate'),
        checkRemoved = localStorage.getItem("weekDateRemoved");        
        if( checkRemoved != null ){            
            this.container.closest('.step1').classList.add('hide');
        }
        else if( has_week_date != '' && has_week_date != null ){            
            this.container.closest('.step1').classList.add('hide');
        }else{
            this.container.closest('.step1').classList.remove('hide');
        }

        // console.log("this.validDays, ", this.validDays, this.firstDay);

        this.init();
        this.isSingleDayDelivery();
        this.renderCart();   
        this.bindOnSubmit(); 
        this.onClose();        

        localStorage.setItem('currentDate', this.currentDate);
        localStorage.setItem('currentDay', this.currentDay);
        localStorage.setItem('minOrderAmount', this.currentZone['min_delivery_amount']);
        localStorage.setItem('slideOut', 'main');
        this.updateOrderHeadingDates();
        this.renderCart();   
        
        let elms = document.querySelectorAll(".saving.menu-b #saving");
        elms.forEach((elm) => {
            elm.addEventListener('change', (event) => {
                event.stopPropagation();
                this.is_saving = elm.checked;
                elms.forEach((e) => {
                    e.checked = this.is_saving;
                });

                if(elm.checked){
                    document.querySelectorAll(".saving.desktop input#subscription").forEach((inputonetime)=>{
                        inputonetime.checked = true;
                    });
                }else{
                    document.querySelectorAll(".saving.desktop input#purchase").forEach((inputonetime)=>{
                        inputonetime.checked = true;
                    });
                }
                this.renderCart();
                this.updateProductCards(this.is_saving);
            });
        });
        
        let elmsdesktop = document.querySelectorAll(".saving.desktop input");
        elmsdesktop.forEach((elm) => {
            elm.addEventListener('change', (event) => {
                event.stopPropagation();
                var get_val = event.target.getAttribute('id');
                if(get_val == 'subscription'){
                    document.querySelector(".saving.menu-b #saving").checked = true;
                    this.is_saving = true;
                }else{
                    document.querySelector(".saving.menu-b #saving").checked = false;
                    this.is_saving = false;
                }
                this.renderCart();
                this.updateProductCards(this.is_saving);
            });
        });

        this.hideDeliveryButton();
        this.searchFilter = new SearchFilter(data, this.startDate);     
        new MealDetail();   
        window.li_click = this;

    }

    updateProductCards(is_checked){
        let cards = document.querySelectorAll(".unselected.meal_selection_price");
        cards.forEach((card) => {            
            card.classList.add("no-sub");
            if(is_checked){
                card.classList.remove("no-sub");                
            }
        });
        cards = document.querySelectorAll(".bottom-item .meal_price");
        cards.forEach((card) => {            
            card.classList.add("no-sub");
            if(is_checked){
                card.classList.remove("no-sub");                
            }
        });
    }

    isPostalCodeMatch(postalCode, postalCodesList) {
        postalCode = postalCode.toLocaleLowerCase();
        const matchingCode = postalCodesList.split(',').map(code => code.toLocaleLowerCase().trim()).find(code => postalCode.startsWith(code));
        return matchingCode != null && matchingCode != '';
    }

    getZone(){
        let postalCode = localStorage.getItem('postal_code');
        let zones = this.data[0]['zones'];  
        let allOk = true;   
        zones.forEach((zone) => {
            if(allOk && this.isPostalCodeMatch(postalCode, zone['postal_code'])){
                allOk = false;
                zone['min_delivery_amount'] = parseFloat(zone['min_delivery_amount']);
                zone['delivery_amount'] = parseFloat(zone['delivery_amount']);
                zone['one_day_free_delivery'] = parseFloat(zone['one_day_free_delivery']);
                zone['more_day_free_delivery'] = parseFloat(zone['more_day_free_delivery']);
                this.currentZone = zone;
            }
        });
        this.subscriptionDiscount = parseInt(this.data[0]['subscriptionDiscount']);
        this.sellingPlans = this.data[0]['sellingPlans'];

        if(this.currentZone == ''){
            this.currentZone = {
                "postal_code": "",
                "delivery_amount": 16.00,
                "min_delivery_amount": 80,
                "one_day_free_delivery": "400",
                "more_day_free_delivery": "500"
            };
        }
    }

    onClose(){
        window.onclick = function(event) {
            event.stopPropagation();
            if (event.target.classList.contains("overlay")) {
                document.querySelector('.slideout-sec.delivery-schedule').classList.remove("active");
            }
        }
    }
    
    updateFreeGift(subtotal_amount){
        if(this.freeGiftPromo != null && this.freeGiftPromo['free_gift']){
            let product = this.freeGiftPromo['free_gift'];
            product['quantity'] = 1;
            this.isFreeProductAddedOld = this.isFreeProductAdded;
            if(this.freeGiftPromo['enable']){
                if(subtotal_amount >= parseFloat(this.freeGiftPromo['min_trigger_value'])){
                    this.isFreeProductAdded = true;
                    this.addOrUpdateCart(product, false);
                    document.querySelector(".order_summary_cont .order_summary .summary").classList.add("free-gift");
                    document.querySelector(".summary-drawer-inner .meal-summary").classList.add("free-gift");
                    document.querySelector(".summary.desk-summary").classList.add("free-gift");
                    document.querySelector(".mobile_order_summary_cont").classList.add("free-gift");                    
                }else if(subtotal_amount < parseFloat(this.freeGiftPromo['min_trigger_value'])){
                    this.isFreeProductAdded = false;
                    this.addOrUpdateCart(product, true);
                    document.querySelector(".order_summary_cont .order_summary .summary").classList.remove("free-gift");
                    document.querySelector(".summary-drawer-inner .meal-summary").classList.remove("free-gift");
                    document.querySelector(".summary.desk-summary").classList.remove("free-gift");
                    document.querySelector(".mobile_order_summary_cont").classList.remove("free-gift");                    
                }                    
            }
            this.isFreeProductAddedOld = this.isFreeProductAdded;
        }        
    }

    modalEventsBinding(){   
        this.deliveryScheduleOuter = document.querySelector(".act-delivery-schedule");
        this.deliveryScheduleModal = document.querySelector(".slideout-sec.delivery-schedule");
        
        var $this = this;
        if(this.deliveryScheduleOuter){
            this.deliveryScheduleOuter.addEventListener('click', function (event) {
                if($this.deliveryScheduleModal){
                    $this.deliveryScheduleModal.classList.add("active");
                    localStorage.setItem('slideOut', 'main');
                }
            });
        }
        
        if(this.deliveryScheduleModal){
            this.deliverySchduleModalClose = this.deliveryScheduleModal.querySelector(".slideout-sec__inner.delivery-schedule__inner #ds__close");
            if(this.deliverySchduleModalClose){
                this.deliverySchduleModalClose.addEventListener('click', function (event) {
                    if($this.deliveryScheduleModal){
                        $this.deliveryScheduleModal.classList.remove("active");
                    }
                });
            }
        }
        
        this.onClose();

        this.deliverySchduleModalSubmit = this.deliveryScheduleModal.querySelector('.btn.btn-cta.btns.btn--success');        
        this.deliverySchduleModalSubmit.addEventListener('click', function (event) {
            if($this.deliveryScheduleModal){
                $this.deliveryScheduleModal.classList.remove("active");
                if(localStorage.getItem('slideOut') == 'cart'){
                    document.querySelector(".total_order_amount_btn").click();
                }
            }
        });
    }

    applyWeekDayChanges(weekDay){
        var $this = this;
        this.data.forEach((currentItem) => {
            if($this.cartJson[currentItem['start_date']] == null){
                $this.cartJson[currentItem['start_date']] = {'counter': 0};
            }
            currentItem.delivery_days.forEach((dayNumber) => {
                if(dayNumber == weekDay && 
                    $this.cartJson[currentItem['start_date']][dayNumber] == null){
                    $this.cartJson[currentItem['start_date']][dayNumber] = {
                        'lineItems': [], 
                        'counter': 0, 
                        'total_price': 0, 
                        'total_compare_price': 0, 
                        'savings': 0, 
                        'tax': parseFloat($this.currentZone['delivery_amount']),
                        'grand_total': 0,
                        'grand_total_org': 0,
                        'is_active': false,
                        'delivery_window': $this.dayWiseTimeSlots[dayNumber][0],
                        'full_date': this.fullDate
                    };
                }
            });            
        });
    }

    sortDays(daysArray) {
        const dayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return daysArray.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
    }  

    isDaysChanged(){
        let days = this.validDays;
        let oldDays = Object.keys(this.cartJson[this.currentDate]);
        let skipList = ['counter', 'meals_total', 'order_total', 'order_saving', 'order_tax'];
        oldDays = oldDays.filter(item => !skipList.includes(item));

        if(oldDays != days){
            oldDays.forEach((day) => {
                if(!this.dayKeys.includes(day)){
                    if(!days.includes(day)){
                        setTimeout(function(){
                            localStorage.removeItem("currentDate");
                            localStorage.removeItem("currentDay");
                            localStorage.removeItem("cartJSON");
                            window.location.reload();
                        }, 3500);
                    }
                }
            });                        
        }
    }

    // isSingleDayDelivery(){   
    //     if(this.cartJson[this.currentDate] != null){
    //         let daysCount = Object.keys(this.cartJson[this.currentDate]).length - 5;
    //         this.isSingleDay = daysCount > 1 ? false : true;

isSingleDayDelivery(){   
    if(this.cartJson[this.currentDate] != null){
         let daysCount = 0;
        Object.keys(this.cartJson[this.currentDate]).forEach((key) => {
            if(!this.dayKeys.includes(key)){
                daysCount++;
            }
        });
        this.isSingleDay = daysCount > 1 ? false : true;


        

            this.tiers = [];
            if(this.isSingleDay){
                this.tiers.push(this.currentZone['one_day_free_delivery']);
            }else{
                this.tiers.push(this.currentZone['more_day_free_delivery']);
            }

            if(this.freeGiftPromo['enable']){
                this.tiers.push(this.freeGiftPromo['min_trigger_value']);
            }

            if(this.perDiscountPromo['enable']){
                this.tiers.push(this.perDiscountPromo['min_trigger_value']);
            }
        }
    }

    getCartObject(){
        let $json = JSON.parse(localStorage.getItem("cartJSON") || '{}');
        window.has_json_value = window.has_json_value == undefined && Object.keys($json).length == 0 ? 0 : Object.keys($json).length;
        let $this = this;

        var days = [];
        var dateWiseDays = {};
        if($json[$this.currentDate] != null){
            if(dateWiseDays[$this.currentDate] == null){
                dateWiseDays[$this.currentDate] = {'days': []};
            }
            Object.keys($json[$this.currentDate]).forEach((day) => {
                if(!this.dayKeys.includes(day)){                    
                    dateWiseDays[$this.currentDate]['days'].push(day);
                    days.push(day);
                }
            });
        }

        days = this.sortDays(days);
        if(days.length > 0){
            this.firstDay = days[0];
            this.currentDay = this.firstDay;
        }
        
        this.data.forEach((currentItem,main_index) => {
            if($json[currentItem['start_date']] == null){
                $json[currentItem['start_date']] = {'counter': 0};
            }
            let currentWeekData = $this.data.find(week => week.start_date === currentItem['start_date']);    
            let itemFirstDay = currentWeekData.delivery_days[0];
            
            if( dateWiseDays[currentWeekData.start_date] && 
                dateWiseDays[currentWeekData.start_date]['days'].length > 0){
                let sortedDays = this.sortDays(dateWiseDays[currentWeekData.start_date]['days']);
                itemFirstDay = sortedDays[0];
            }
            
            if($json[currentItem['start_date']][itemFirstDay] == null && 
                currentWeekData.delivery_days.includes(itemFirstDay)
            ){
                
                if ( window.onlyRunOunce == undefined && window.has_json_value == 0 ){
                    // Create a new options object for each day
                    currentWeekData.delivery_days.forEach((de_day) => {                  
                        $json[currentItem['start_date']][de_day] = {
                            'lineItems': [], 
                            'counter': 0, 
                            'total_price': 0, 
                            'total_compare_price': 0, 
                            'savings': 0, 
                            'tax': parseFloat(this.currentZone['delivery_amount']),
                            'grand_total': 0,
                            'grand_total_org': 0,
                            'is_active': false,
                            'delivery_window': $this.dayWiseTimeSlots[de_day][0],
                            'full_date': $this.fullDate
                        };
                    });
                }else{
                    $json[currentItem['start_date']][itemFirstDay] = {
                        'lineItems': [], 
                        'counter': 0, 
                        'total_price': 0, 
                        'total_compare_price': 0, 
                        'savings': 0, 
                        'tax': parseFloat(this.currentZone['delivery_amount']),
                        'grand_total': 0,
                        'grand_total_org': 0,
                        'is_active': false,
                        'delivery_window': $this.dayWiseTimeSlots[itemFirstDay][0],
                        'full_date': $this.fullDate
                    };
                }
            }
            if( (main_index + 1) == $this.data.length ){
                window.onlyRunOunce = true;
                window.has_json_value = 1;
            }
        });

        return $json;
    }

    addOrUpdateCart(item, isRemove){
      if(this.cartJson[this.currentDate] == null){
        this.cartJson[this.currentDate] = {'counter': 0};
      }

      let currentWeekData = this.data.find(week => week.start_date === this.currentDate);    
      if(this.cartJson[this.currentDate][this.currentDay] == null && currentWeekData.delivery_days.includes(this.currentDay)){
        this.cartJson[this.currentDate][this.currentDay] = {
            'lineItems': [], 
            'counter': 0, 
            'total_price': 0, 
            'total_compare_price': 0, 
            'savings': 0, 
            'tax': parseFloat(this.currentZone['delivery_amount']),
            'grand_total': 0,
            'grand_total_org': 0,
            'is_active': false,
            'delivery_window': this.dayWiseTimeSlots[this.currentDay][0],
            'full_date': this.fullDate
        };
      }
      
      if(this.cartJson[this.currentDate][this.currentDay] != null){
        let lineItems = this.cartJson[this.currentDate][this.currentDay]['lineItems'];
        let isAdd = true;
        let indexer = 0;
        lineItems.forEach((lineItem) => {
            if(lineItem['id'] == item['id']){
            isAdd = false;
            item['selling_plan_id'] = this.sellingPlans[this.currentDay]['id'];
            item['plan_name'] = this.currentDay;
            item['plan_date'] = this.checkDay(this);
            lineItems[indexer] = item;
            }
            if(isAdd)
            indexer++;
        });

        if(isAdd && isRemove == false){
            item['selling_plan_id'] = this.sellingPlans[this.currentDay]['id'];
            item['plan_name'] = this.currentDay;
            item['plan_date'] = this.checkDay(this);
            lineItems.push(item);
        }else if(isRemove){
            lineItems.splice(indexer, 1);
        }

        this.cartJson[this.currentDate][this.currentDay]['lineItems'] = lineItems;         
      }      
      if( (item.price == 0 && this.isFreeProductAddedOld != this.isFreeProductAdded) || (item.price > 0) ){
        this.updateCounters();
      }
        
        localStorage.setItem("cartJSON", JSON.stringify(this.cartJson));
        setWithExpiry('cartData', 3);

        if( (item.price == 0 && this.isFreeProductAddedOld != this.isFreeProductAdded) || item.price > 0){
            this.renderCart();
        }
        this.updateOrderHeadingDates();
    }

    checkDay(objItem){
        var Dayname = objItem.currentDay.toLowerCase();
        var GetDate = objItem.currentDate;
        var numberOfDaysToAdd = 0;
        if(Dayname == 'sunday'){
            return GetDate;
        }else if(Dayname == 'monday'){
            numberOfDaysToAdd = 1;
        }else if(Dayname == 'tuesday'){
            numberOfDaysToAdd = 2;
        }else if(Dayname == 'wednesday'){
            numberOfDaysToAdd = 3;
        }else if(Dayname == 'thursday'){
            numberOfDaysToAdd = 4;
        }else if(Dayname == 'friday'){
            numberOfDaysToAdd = 5;
        }else if(Dayname == 'saturday'){
            numberOfDaysToAdd = 6;
        }
        // Create date object with time set to noon to avoid timezone issues

        GetDate = new Date(GetDate + 'T12:00:00');
        var result = new Date(GetDate.setDate(GetDate.getDate() + numberOfDaysToAdd));

        return `${result.getFullYear()}-${result.getMonth() + 1}-${result.getDate()}`;
    }

    formatNumber(number){
        return (Math.round(number * 100) / 100).toFixed(2);
    }

    formatedStartEndDates(start_date, end_date){
        if(end_date == null || end_date == ""){
            return this.formateDate(start_date);    
        }

        return this.formateDate(start_date) + " - " + this.formateDate(end_date);
    }

    formateDate(date){
        let cDate = new Date(date);
        let options = { month: 'short', day: 'numeric', timeZone: 'UTC' };

        return cDate.toLocaleDateString('en-US', options);
    }

    updateCounters(){        
        Object.keys(this.cartJson).forEach(date => {
            this.cartJson[date]['counter'] = 0;
            this.cartJson[date]['meals_total'] = 0;
            this.cartJson[date]['order_total'] = 0;
            this.cartJson[date]['order_saving'] = 0;
            this.cartJson[date]['order_tax'] = 0;
            Object.keys(this.cartJson[date]).forEach(day => {
                if(!this.dayKeys.includes(day)){
                    this.cartJson[date][day]['counter'] = 0;
                    this.cartJson[date][day]['total_price'] = 0;
                    this.cartJson[date][day]['total_compare_price'] = 0;
                    this.cartJson[date][day]['lineItems'].forEach((item, index) => {
                        if(!this.dayKeys.includes(item)){
                            this.cartJson[date][day]['counter'] += item.quantity;
                            // console.log("----this.is_saving: ", this.is_saving);
                            if(this.is_saving == true){
                                this.cartJson[date][day]['total_price'] += (parseFloat(item.quantity) * parseFloat(item.price));
                                this.cartJson[date][day]['total_compare_price'] += (parseFloat(item.quantity) * parseFloat(item.compare_at_price));

                                this.cartJson[date]['order_total'] += (parseFloat(item.quantity) * parseFloat(item.price));
                                this.cartJson[date]['meals_total'] += (parseFloat(item.quantity) * parseFloat(item.compare_at_price));
                            }else{
                                this.cartJson[date][day]['total_price'] += (parseFloat(item.quantity) * parseFloat(item.compare_at_price));
                                this.cartJson[date][day]['total_compare_price'] += (parseFloat(item.quantity) * parseFloat(item.compare_at_price));

                                this.cartJson[date]['meals_total'] += (parseFloat(item.quantity) * parseFloat(item.compare_at_price));
                                this.cartJson[date]['order_total'] += (parseFloat(item.quantity) * parseFloat(item.compare_at_price));
                            }   
                        }
                    });
                    this.cartJson[date]['order_saving'] += (this.cartJson[date][day]['total_compare_price'] - this.cartJson[date][day]['total_price']);
                    this.cartJson[date]['counter'] += this.cartJson[date][day]['counter'];
                    this.cartJson[date][day]['savings'] = this.formatNumber(this.cartJson[date][day]['total_compare_price'] - this.cartJson[date][day]['total_price']);
                    this.cartJson[date][day]['is_active'] = false;

                    if(parseFloat(this.cartJson[date][day]['total_price']) >= this.currentZone['min_delivery_amount']){
                        this.cartJson[date][day]['is_active'] = true;
                    }
                    this.cartJson[date][day]['tax'] = this.currentZone['delivery_amount']                    
                    if(this.cartJson[date][day]['lineItems'].length == 0){
                        this.cartJson[date][day]['tax'] = 0.0;
                    }
                     
                    this.cartJson[date]['order_tax'] += parseFloat(this.cartJson[date][day]['tax']);
                    // let daysCount = Object.keys(this.cartJson[this.currentDate]).length - 5;
                    // this.isSingleDay = daysCount > 1 ? false : true;
                    if(this.isSingleDay){
                        if(this.cartJson[date]['order_total'] >= this.currentZone['one_day_free_delivery']){
                            this.cartJson[date][day]['tax'] = 0.0;
                            this.cartJson[date]['order_tax'] = 0;
                        }
                    }else{
                        if(this.cartJson[date]['order_total'] >= this.currentZone['more_day_free_delivery']){
                            this.cartJson[date][day]['tax'] = 0.0;
                            this.cartJson[date]['order_tax'] = 0;
                        }
                    }      
                    
                    this.cartJson[date][day]['tax'] = this.formatNumber(this.cartJson[date][day]['tax']);
                    this.cartJson[date][day]['grand_total'] = this.formatNumber(parseFloat(this.cartJson[date][day]['total_price']) + parseFloat(this.cartJson[date][day]['tax']));
                    this.cartJson[date][day]['grand_total_org'] = this.formatNumber(parseFloat(this.cartJson[date][day]['total_compare_price']) + parseFloat(this.cartJson[date][day]['tax']));
                    this.cartJson[date][day]['total_price'] = this.formatNumber(this.cartJson[date][day]['total_price']);                                        
                }
            });
        });        
    }

    bindCartEvents(){
        /* we define new function li_click so we are returning user from here */
        return;
      var days = document.querySelectorAll(".order__week-daysname > .days");
      var $this = this;
      days.forEach((day) => {
        /*day.addEventListener('click', (event) => {
          event.stopPropagation();

            var target = event.target;
            var dayNumber = target.getAttribute('data-day');
            var dayDate = target.getAttribute('data-date');
            console.log(dayNumber,dayDate);
            
            $this.currentDay = dayNumber;
            $this.currentDate = dayDate;

            let active = document.querySelector(".order__week-daysname .days.active");
            if(active){
                active.classList.remove("active");
                // active.querySelector(".os_total-select-order").classList.add("zero-selected");
            }            

            target.classList.add("active");
            //   target.querySelector(".os_total-select-order").classList.remove("zero-selected");

            $this.renderCart();       
        });*/
      });      
    }

    li_click(event,day,currentDate){
        event.stopPropagation();
        var target = event.target;
        
        this.currentDay = day;
        this.currentDate = currentDate;

        let active = document.querySelector(".order__week-daysname .days.active");
        if(active){
            active.classList.remove("active");
        }            

        target.classList.add("active");

        this.renderCart();
    }

    updateProgressBar(meals_total) {
        const maxTierValue = Math.max(...this.tiers);
        var percentage = (meals_total / maxTierValue) * 100;
        const progressBars = document.querySelectorAll('.meal_orders_cont .progress_bar_cont .progress_bar .fill');
        // const progressBars = document.querySelectorAll('.fill');
        progressBars.forEach((progressBar) => {
            if(percentage > 100){
                percentage = 100;
            }
            progressBar.style.width = percentage + "%";
        });
        this.setProgressBarLabels(meals_total);
    }

    updateMobileProgressLabel(meals_total){
        //document.querySelector(".promo-container").classList.remove("hide");
        let elm = document.querySelector(".mobile_order_summary_cont .meal_orders_cont .progress_bar_cont > p.free-delv-text");
        
        let freeGiftPromo = -1;
        if(this.freeGiftPromo['enable']){
            freeGiftPromo = parseFloat(this.freeGiftPromo['min_trigger_value']);
        }
        let perDiscountPromo = -1;
        if(this.perDiscountPromo['enable']){
            perDiscountPromo = parseFloat(this.perDiscountPromo['min_trigger_value']);
        }
        let diff = 0;
        if(this.isSingleDay){
            if(meals_total < this.currentZone['one_day_free_delivery']){
                diff = this.formatNumber(this.currentZone['one_day_free_delivery'] - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Delivery</b>`;
            }else if(meals_total > this.currentZone['one_day_free_delivery'] && 
                perDiscountPromo != -1 &&
                meals_total < perDiscountPromo
            ){
                diff = this.formatNumber(perDiscountPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Discount Promo</b>`;
            }else if(meals_total > this.currentZone['one_day_free_delivery'] && 
                freeGiftPromo != -1 &&
                meals_total < freeGiftPromo
            ){
                diff = this.formatNumber(freeGiftPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Gift</b>`;
            }else{
                //document.querySelector(".promo-container").classList.add("hide");
                elm.innerHTML = ``;
            }
        }else{
            if(meals_total < this.currentZone['more_day_free_delivery']){
                diff = this.formatNumber(this.currentZone['more_day_free_delivery'] - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Delivery</b>`;
            }else if(meals_total > this.currentZone['more_day_free_delivery'] && 
                perDiscountPromo != -1 &&
                meals_total < perDiscountPromo
            ){
                diff = this.formatNumber(perDiscountPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Discount Promo</b>`;
            }else if(meals_total > this.currentZone['more_day_free_delivery'] && 
                freeGiftPromo != -1 &&
                meals_total < freeGiftPromo
            ){
                diff = this.formatNumber(freeGiftPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Gift</b>`;
            }else{
                //document.querySelector(".promo-container").classList.add("hide");
                elm.innerHTML = ``;
            }
        }
    }

    setProgressBarLabels(meals_total){
        this.updateMobileProgressLabel(meals_total);

        //document.querySelector(".promo-container").classList.remove("hide");
        this.promoDiscountAmount = 0;
        let elm = document.querySelector(".meal_orders_cont .progress_bar_cont > p.free-delv-text");
        document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.remove("active");
        document.querySelector("#get_discount > span").textContent = `${this.perDiscountPromo['discount_value']}% Discount`;        
        document.querySelector(".discount.promo").classList.add("hide");
        document.querySelector(".discount.promo > p").textContent = `-${this.perDiscountPromo['discount_value']}% OFF`;
        document.querySelector(".delivery-tax.promo-discount > p").textContent = `-${this.perDiscountPromo['discount_value']}% OFF`;
        document.querySelector(".delivery-tax.promo-discount").classList.add("hide");

        document.querySelector(".mobile_order_summary_cont").classList.remove("free-delivery");
        document.querySelector(".desk-summary").classList.remove("free-delivery");
        document.querySelector(".order-summary-drawer").classList.remove("free-delivery");

        document.querySelector(".mobile_order_summary_cont").classList.remove("free-discount");
        document.querySelector(".desk-summary").classList.remove("free-discount");
        document.querySelector(".order-summary-drawer").classList.remove("free-discount");

        document.querySelector(".mobile_order_summary_cont").classList.remove("free-gift");
        document.querySelector(".desk-summary").classList.remove("free-gift");
        document.querySelector(".order-summary-drawer").classList.remove("free-gift");

        let elms = document.querySelectorAll(".tiers-level .oc-free-gift");
        elms.forEach((el) => {
            el.classList.add("hide");
        });
        
        let freeGiftPromo = -1;
        if(this.freeGiftPromo['enable']){
            freeGiftPromo = parseFloat(this.freeGiftPromo['min_trigger_value']);
        }
        let perDiscountPromo = -1;
        if(this.perDiscountPromo['enable']){
            perDiscountPromo = parseFloat(this.perDiscountPromo['min_trigger_value']);
        }
        let diff = 0; 
        let daysCount = 0;

        const skipKeys = ['counter', 'meals_total', 'order_total', 'order_saving', 'order_tax'];
        Object.keys(this.cartJson[this.currentDate]).forEach(key => {
            if (!skipKeys.includes(key)) {
                if(this.cartJson[this.currentDate][key].lineItems.length > 0){
                    daysCount++;
                }
            }
        });
        
        this.isSingleDay = daysCount > 1 ? false : true;
        if(this.isSingleDay){
            if(meals_total < this.currentZone['one_day_free_delivery']){
                diff = this.formatNumber(this.currentZone['one_day_free_delivery'] - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Delivery</b>`;
            }else if(meals_total > this.currentZone['one_day_free_delivery'] && perDiscountPromo != -1 && meals_total < perDiscountPromo){
                document.querySelector(".mobile_order_summary_cont").classList.add("free-delivery");
                document.querySelector(".desk-summary").classList.add("free-delivery");
                document.querySelector(".order-summary-drawer").classList.add("free-delivery");

                document.querySelector("#get_free_delivery").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .free-delivery").classList.remove("hide");                
                document.querySelector(".desk-summary .checkout_prices .delivery-tax").classList.add("active");
                document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.add("active");
                diff = this.formatNumber(perDiscountPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Discount Promo</b>`;
            }else if(meals_total > this.currentZone['one_day_free_delivery'] && freeGiftPromo != -1 && meals_total < freeGiftPromo){
                if(perDiscountPromo != -1){
                    document.querySelector(".mobile_order_summary_cont").classList.add("free-discount");
                    document.querySelector(".desk-summary").classList.add("free-discount");
                    document.querySelector(".order-summary-drawer").classList.add("free-discount");

                    document.querySelector("#get_discount").classList.remove("hide");
                    document.querySelector(".mobile_order_summary_cont .free-discount").classList.remove("hide");
                    document.querySelector(".order-summary-drawer .oc-free-gift.promo-discount").classList.remove("hide");
                    document.querySelector(".discount.promo").classList.remove("hide");
                    //document.querySelector(".promo-container").classList.add("hide");
                    let discount = this.formatNumber((parseFloat(this.perDiscountPromo['discount_value']) / 100.0) * meals_total);
                    document.querySelector(".discount.promo > h3").textContent = `-$${discount}`;
                    document.querySelector(".delivery-tax.promo-discount > h3").textContent = `-$${discount}`;
                    this.promoDiscountAmount = discount;
                }

                document.querySelector("#get_free_delivery").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .free-delivery").classList.remove("hide");
                document.querySelector(".desk-summary .checkout_prices .delivery-tax").classList.add("active");
                document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.add("active");                
                diff = this.formatNumber(freeGiftPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Gift</b>`;
            }else{
                document.querySelector(".mobile_order_summary_cont").classList.add("free-gift");
                document.querySelector(".desk-summary").classList.add("free-gift");
                document.querySelector(".order-summary-drawer").classList.add("free-gift");

                document.querySelector("#get_free_delivery").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .free-delivery").classList.remove("hide");                                
                if(freeGiftPromo != -1){
                    document.querySelector("#get_free_gift").classList.remove("hide");
                    document.querySelector(".mobile_order_summary_cont .free-gift").classList.remove("hide");
                }            
                if(perDiscountPromo != -1){
                    document.querySelector("#get_discount").classList.remove("hide");
                    document.querySelector(".mobile_order_summary_cont .free-discount").classList.remove("hide");
                    document.querySelector(".order-summary-drawer .oc-free-gift.promo-discount").classList.remove("hide");
                    document.querySelector(".discount.promo").classList.remove("hide");
                    document.querySelector(".delivery-tax.promo-discount").classList.remove("hide");
                    let discount = this.formatNumber((parseFloat(this.perDiscountPromo['discount_value']) / 100.0) * meals_total);
                    document.querySelector(".discount.promo > h3").textContent = `-$${discount}`;
                    document.querySelector(".delivery-tax.promo-discount > h3").textContent = `-$${discount}`;
                    this.promoDiscountAmount = discount;
                    //document.querySelector(".promo-container").classList.add("hide");
                }                    
                document.querySelector(".desk-summary .checkout_prices .delivery-tax").classList.add("active");
                document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.add("active");                                
                elm.innerHTML = ``;
            }
            const progressBars = document.querySelectorAll('.meal_orders_cont .progress_bar_cont .progress_bar .fill');
            var percentage = (meals_total / this.currentZone['one_day_free_delivery']) * 100;
            // console.log('percentage1',percentage);
            progressBars.forEach((progressBar) => {
                if(percentage > 100){
                    percentage = 100;
                }
                progressBar.style.width = percentage + "%";
            });
        }else{
            if(meals_total < this.currentZone['more_day_free_delivery']){
                diff = this.formatNumber(this.currentZone['more_day_free_delivery'] - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Delivery</b>`;
            }else if(meals_total > this.currentZone['more_day_free_delivery'] && perDiscountPromo != -1 && meals_total < perDiscountPromo){
                document.querySelector(".mobile_order_summary_cont").classList.add("free-delivery");
                document.querySelector(".desk-summary").classList.add("free-delivery");
                document.querySelector(".order-summary-drawer").classList.add("free-delivery");

                document.querySelector("#get_free_delivery").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .free-delivery").classList.remove("hide");                
                document.querySelector(".desk-summary .checkout_prices .delivery-tax").classList.add("active");
                document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.add("active");
                diff = this.formatNumber(perDiscountPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Discount Promo</b>`;
            }else if(meals_total > this.currentZone['more_day_free_delivery'] && freeGiftPromo != -1 && meals_total < freeGiftPromo){
                if(perDiscountPromo != -1){
                    document.querySelector(".mobile_order_summary_cont").classList.add("free-discount");
                    document.querySelector(".desk-summary").classList.add("free-discount");
                    document.querySelector(".order-summary-drawer").classList.add("free-discount");

                    document.querySelector("#get_discount").classList.remove("hide");
                    document.querySelector(".mobile_order_summary_cont .free-discount").classList.remove("hide");
                    document.querySelector(".order-summary-drawer .oc-free-gift.promo-discount").classList.remove("hide");
                    document.querySelector(".discount.promo").classList.remove("hide");
                    //document.querySelector(".promo-container").classList.add("hide");
                    let discount = this.formatNumber((parseFloat(this.perDiscountPromo['discount_value']) / 100.0) * meals_total);
                    document.querySelector(".discount.promo > h3").textContent = `-$${discount}`;
                    document.querySelector(".delivery-tax.promo-discount > h3").textContent = `-$${discount}`;
                    this.promoDiscountAmount = discount;
                }
                
                document.querySelector("#get_free_delivery").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .free-delivery").classList.remove("hide");
                document.querySelector(".desk-summary .checkout_prices .delivery-tax").classList.add("active");
                document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.add("active");
                diff = this.formatNumber(freeGiftPromo - meals_total);
                elm.innerHTML = `Spend <b>$${diff}</b> more to get <b>Free Gift</b>`;
            }else{
                document.querySelector(".mobile_order_summary_cont").classList.add("free-gift");
                document.querySelector(".desk-summary").classList.add("free-gift");
                document.querySelector(".order-summary-drawer").classList.add("free-gift");

                document.querySelector("#get_free_delivery").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .free-delivery").classList.remove("hide");                                
                if(freeGiftPromo != -1){                    
                    document.querySelector("#get_free_gift").classList.remove("hide");
                    document.querySelector(".mobile_order_summary_cont .free-gift").classList.remove("hide");
                }           
                if(perDiscountPromo != -1){
                    document.querySelector("#get_discount").classList.remove("hide");
                    document.querySelector(".mobile_order_summary_cont .free-discount").classList.remove("hide");
                    document.querySelector(".order-summary-drawer .oc-free-gift.promo-discount").classList.remove("hide");   
                    document.querySelector(".discount.promo").classList.remove("hide");
                    document.querySelector(".delivery-tax.promo-discount").classList.remove("hide");
                    let discount = this.formatNumber((parseFloat(this.perDiscountPromo['discount_value']) / 100.0) * meals_total);
                    document.querySelector(".discount.promo > h3").textContent = `-$${discount}`;
                    document.querySelector(".delivery-tax.promo-discount > h3").textContent = `-$${discount}`;
                    this.promoDiscountAmount = discount;
                    //document.querySelector(".promo-container").classList.add("hide");
                }                     
                document.querySelector(".desk-summary .checkout_prices .delivery-tax").classList.add("active");
                document.querySelector(".order-summary-drawer .checkout_prices .weekly-saving").classList.add("active");                
                elm.innerHTML = ``;
            }
            const progressBars = document.querySelectorAll('.meal_orders_cont .progress_bar_cont .progress_bar .fill');
            var percentage = (meals_total / this.currentZone['more_day_free_delivery']) * 100;
            // console.log('percentage2',percentage);
            progressBars.forEach((progressBar) => {
                if(percentage > 100){
                    percentage = 100;
                }
                progressBar.style.width = percentage + "%";
            });
        }
        
    }

    getOrderMealsTotal(){
        let meals_amount = 0;;
        var days = [];
        if(this.cartJson[this.currentDate] != null){
            Object.keys(this.cartJson[this.currentDate]).forEach((day) => {
                if(!this.dayKeys.includes(day)){
                    days.push(day);
                }
            });
        } 

        days.forEach((dayName) => {
            this.cartJson[this.currentDate][dayName].lineItems.forEach((item) => {
                meals_amount += (item.price * item.quantity);
            });
        });

        return meals_amount;
    }

    desktopDayTabs(currentItem, days){
        
        let $this = this;
        // console.log('counterload',$this.cartJson);
        days.forEach((dayNumber) => {
            if ($this.cartJson[$this.currentDate] &&
                $this.cartJson[$this.currentDate][dayNumber] != null) {

                const li = document.createElement('li');
                li.className = "days";
                li.textContent = dayNumber;
                li.dataset.date = currentItem['start_date'];
                li.dataset.day = dayNumber;    
                li.setAttribute('onclick',`window.li_click.li_click(event,"${dayNumber}","${currentItem['start_date']}")`);

                const span = document.createElement('span');
                span.className = "order_counter";
                var counter = 0;
                if ($this.cartJson[currentItem['start_date']] &&
                    $this.cartJson[currentItem['start_date']][dayNumber] &&
                    $this.cartJson[currentItem['start_date']][dayNumber]['counter']) {
                    counter = $this.cartJson[currentItem['start_date']][dayNumber]['counter'];
                }
                span.textContent = "(" + counter + ")";

                if ($this.freeGiftPromo['enable'] == null) {
                    $this.cartJson[currentItem['start_date']][dayNumber]['lineItems'].forEach((lineItem) => {
                        if (lineItem['price'] == 0) {
                            window.localStorage.removeItem("cartJSON");
                            window.location.reload();
                        }
                    });
                }

                if (dayNumber == $this.currentDay) {
                    li.className = "days active";
                }


                const span2 = document.createElement('span');
                span2.className = "s_week_date";


                var date_format = this.getDateOfTargetDay(currentItem['start_date'], dayNumber);
                //span2.textContent = new Date(date_format).toLocaleString('default', { month: 'long' })+" "+new Date(date_format).getDate();
                var get_curr_Date = new Date(date_format+' 00:00:00');
                // const options = { month: 'long', day: 'numeric', timeZone: 'UTC' };
                const options = { month: 'long', day: 'numeric' };
                span2.textContent = get_curr_Date.toLocaleDateString('en-US', options);
                // span2.textContent = monthNames[get_curr_Date.getMonth()]+" "+currentItem['start_date'];

                li.appendChild(span);
                li.appendChild(span2);
                document.querySelector(".desk-summary .summary__week_name").appendChild(li);                        
            }
        });
        if(document.querySelectorAll(".desk-summary .order__week-daysname .days").length > 1){
            document.querySelector(".desk-summary .order__week-daysname").classList.remove("hide");
        }else{
            document.querySelector(".desk-summary .order__week-daysname").classList.add("hide");
        }
    }

    mobileDayTabs(currentItem, days){
        let $this = this;
        days.forEach((dayNumber) => {
            if ($this.cartJson[$this.currentDate] &&
                $this.cartJson[$this.currentDate][dayNumber] != null) {

                const li = document.createElement('li');
                li.className = "days";
                li.textContent = dayNumber;
                li.dataset.date = currentItem['start_date'];
                li.dataset.day = dayNumber;
                li.setAttribute('onclick',`window.li_click.li_click(event,"${dayNumber}","${currentItem['start_date']}")`);              

                const span = document.createElement('span');
                span.className = "order_counter";
                var counter = 0;
                if ($this.cartJson[currentItem['start_date']] &&
                    $this.cartJson[currentItem['start_date']][dayNumber] &&
                    $this.cartJson[currentItem['start_date']][dayNumber]['counter']) {
                    counter = $this.cartJson[currentItem['start_date']][dayNumber]['counter'];
                }
                span.textContent = "(" + counter + ")";

                if ($this.freeGiftPromo['enable'] == null) {
                    $this.cartJson[currentItem['start_date']][dayNumber]['lineItems'].forEach((lineItem) => {
                        if (lineItem['price'] == 0) {
                            window.localStorage.removeItem("cartJSON");
                            window.location.reload(); 
                        }
                    });
                }

                if (dayNumber == $this.currentDay) {
                    li.className = "days active";
                }

                const span2 = document.createElement('span');
                span2.className = "s_week_date";
                var date_format = this.getDateOfTargetDay(currentItem['start_date'], dayNumber);
                //span2.textContent = new Date(date_format).toLocaleString('default', { month: 'long' })+" "+new Date(date_format).getDate();
                var get_curr_Date = new Date(date_format+' 00:00:00');
                // const options = { month: 'long', day: 'numeric', timeZone: 'UTC' };
                const options = { month: 'long', day: 'numeric' };
                span2.textContent = get_curr_Date.toLocaleDateString('en-US', options);

                li.appendChild(span);
                li.appendChild(span2);
                document.querySelector(".mobile_order_summary_cont .summary__week_name").appendChild(li);
            }
        });
        if(document.querySelectorAll(".mobile_order_summary_cont .order__week-daysname .days").length > 1){
            document.querySelector(".mobile_order_summary_cont .order__week-daysname").classList.remove("hide");
        }else{
            document.querySelector(".mobile_order_summary_cont .order__week-daysname").classList.add("hide");
        }
    }

    hideContentWhenNoItems(menuMeals){
        let hideContents = document.querySelectorAll(".empty-hide");
        if(menuMeals.length == 0){            
            hideContents.forEach((hideContent)=> {
                hideContent.classList.add("hide");
            });
            // document.querySelector(".desk-summary .checkout_prices .total_order_amount").classList.add("mgtop");
        }else{
            hideContents.forEach((hideContent)=> {
                hideContent.classList.remove("hide");
            });
            // document.querySelector(".desk-summary .checkout_prices .total_order_amount").classList.remove("mgtop");

            // if(this.isSingleDay){
            //     document.querySelector(".summary_plus2week_subtotal").classList.add("hide");
            //     document.querySelector(".multidays-sect").classList.add("hide");
            //     document.querySelector(".mobile_order_summary_cont .meal-image.prodslist").classList.remove("hide");
            // }else{
            //     document.querySelector(".summary_plus2week_subtotal").classList.remove("hide");
            //     document.querySelector(".multidays-sect").classList.remove("hide");
            //     document.querySelector(".mobile_order_summary_cont .meal-image.prodslist").classList.add("hide");
            // }

            if(this.isSingleDay){
                document.querySelectorAll(".multidays-sect").forEach(el => el.classList.add("hide"));
                document.querySelector(".mobile_order_summary_cont .meal-image.prodslist").classList.remove("hide");
            }else{
                document.querySelectorAll(".multidays-sect").forEach(el => el.classList.remove("hide"));
                document.querySelector(".mobile_order_summary_cont .meal-image.prodslist").classList.add("hide");
            }




        }        
    }

    renderCart(){   
        if(document.querySelectorAll(".order__week-daysname .days").length > 1){
            document.querySelector(".order__week-daysname").classList.remove("hide");
        }else{
            document.querySelector(".order__week-daysname").classList.add("hide");
        }

        const ordersContainer = document.querySelector(".orders");
        ordersContainer.innerHTML = '';
        // document.querySelector(".order_counter").textContent = "(0)";
        let $this = this;

        this.data.forEach((currentItem) => {
            if (currentItem['start_date'] == this.currentDate) {
                document.querySelector(".mobile_order_summary_cont .summary__week_name").innerHTML = '';
                document.querySelector(".desk-summary .summary__week_name").innerHTML = '';                
        
                var days = [];
                if ($this.cartJson[$this.currentDate] != null) {
                    Object.keys($this.cartJson[$this.currentDate]).forEach((day) => {
                        if (!this.dayKeys.includes(day)) {
                            days.push(day);
                        }
                    });
                }        
                days = $this.sortDays(days);

                if (days.length == 0) {
                    days = currentItem['delivery_days'];
                    $this.currentDay = $this.firstDay();

                    if ($this.cartJson[$this.currentDate] == null) {
                        $this.cartJson[$this.currentDate] = { 'counter': 0 };
                    }
        
                    if ($this.cartJson[$this.currentDate][$this.currentDay] == null) {
                        $this.cartJson[$this.currentDate][$this.currentDay] = {
                            'lineItems': [],
                            'counter': 0,
                            'total_price': 0,
                            'total_compare_price': 0,
                            'savings': 0,
                            'tax': parseFloat($this.currentZone['delivery_amount']),
                            'grand_total': 0,
                            'grand_total_org': 0,
                            'is_active': false,
                            'delivery_window': $this.dayWiseTimeSlots[$this.currentDay][0],
                            'full_date': $this.fullDate
                        };
                    }
                }
        
                $this.desktopDayTabs(currentItem, days);
                $this.mobileDayTabs(currentItem, days);
                $this.updateOrderHeadingDates(currentItem, days);
            }
        });        

        document.querySelector(".mobile_order_summary_cont .order_summary .meal-image").innerHTML = '';
        let menuMeals = [];
        var storethis = this;
        document.querySelectorAll('.unselected.hide').forEach((hidediv) => {
            hidediv.parentNode.querySelector('.selected').classList.add('hide');
            hidediv.classList.remove('hide')
        })      
        if(this.cartJson[this.currentDate] && this.cartJson[this.currentDate][this.currentDay]){
            this.cartJson[this.currentDate][this.currentDay].lineItems.forEach((item) => {
                var productSelector = document.querySelector('.meal[data-id="'+item.id+'"]');
                if(productSelector){
                    productSelector.querySelector('.meal_count').innerHTML = item.quantity;
                    productSelector.querySelector('.meal_count').setAttribute(('data-' + storethis.currentDay),item.quantity);
                    if(item.quantity == 1){
                        productSelector.querySelector('.unselected').classList.add('hide');
                        productSelector.querySelector('.selected').classList.remove('hide');
                        productSelector.querySelector('.delete.qty').classList.remove('hide');
                        productSelector.querySelector('.quantity[data-action="minus"]:not(.delete)').classList.add('hide');
                    }else if(item.quantity > 1){
                        productSelector.querySelector('.unselected').classList.add('hide');
                        productSelector.querySelector('.selected').classList.remove('hide');
                        productSelector.querySelector('.quantity[data-action="minus"]:not(.delete)').classList.remove('hide');
                        productSelector.querySelector('.delete.qty').classList.add('hide');
                    }
                }
                
                let priceHTML = `<div class="order_price_cont">
                                <p class="actual">${item.price == 0 ? 'FREE' : '$' + item.price}</p>
                                <p class="discount ${ item.price == 0 ? 'hide' : '' }">$${item.compare_at_price}</p>
                            </div>`;
                if(this.is_saving == false){
                    priceHTML = `<div class="order_price_cont">
                                <p class="actual">$${item.compare_at_price}</p>
                            </div>`;
                }
                let orderHTML = ''
                if(item.price == 0){
                    orderHTML = `<div class="order otr-meal-card summary__free_gift" data-day="${this.currentDay}">
                            <div class="fg__info">
                                <img src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/gift-icon.png?v=1729506741" alt="free gift" width="30" height="30">
                                <p>${item.title}</p>
                            </div>
                            <div class="amount">FREE</div>
                        </div>`;
                }else{
                    orderHTML = `<div class="order otr-meal-card ${ item.price == 0 ? 'welcome-gift' : '' }" data-day="${this.currentDay}">
                            <img
                                class="order_image"
                                src="${item.image}"
                                alt="${item.title}" />
                            <div class="order_info">
                                <div class="order_name_cont">
                                    <h4>${item.title}</h4>
                                    ${priceHTML}
                                </div>
                                <div class="order_amount ${ item.price == 0 ? 'hide' : '' }">
                                    <img data-id="${item.id}" class="qty can delete ${item.quantity == 1 ? '' : 'hide'}" data-action="delete" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/dustbin.svg?v=1725437510" alt="Delete">
                                    <img
                                        class="qty minus ${item.quantity == 1 ? 'hide' : ''}"
                                        src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/black_minus.svg?v=1725365256"
                                        alt="Minus"
                                        data-id="${item.id}"
                                    >
                                    <p class="inpt-quantity" data-id="${item.id}">${item.quantity}</p>
                                    <img
                                        class="qty plus"
                                        src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/black_plus.svg?v=1725365263"
                                        alt="Plus"
                                        data-id="${item.id}"
                                    >
                                </div>
                            </div>
                        </div>`;
                }                

                menuMeals.push(`<div class="order-image"><div class="media-img"><img src="${item.image}" height="auto" width="auto" /></div></div>`);

            ordersContainer.innerHTML += orderHTML;
            });

            document.querySelector(".empty-order-box").classList.remove("hide");
            if(menuMeals.length > 0){
                document.querySelector(".empty-order-box").classList.add("hide");
            }

            document.querySelector(".mobile_order_summary_cont .order_summary .meal-image").innerHTML = menuMeals.join('');
        }       
        document.querySelector(".checkout_prices .delivery-tax").classList.remove("active");
        this.hideContentWhenNoItems(menuMeals);             

        let $meals_amount = this.getOrderMealsTotal();
        // setTimeout(function(){
            $this.updateFreeGift($meals_amount);
            $this.updateProgressBar($meals_amount);        
        // }, 50);

        var elms =  ordersContainer.querySelectorAll(".order_amount > .qty");
        elms.forEach((elm) => {
            elm.addEventListener('click', (event) => {
            const target = event.target;
            const itemId = target.getAttribute('data-id');

            if (target.classList.contains('minus')) {
                $this.updateQuantity(itemId, -1);
            } else if (target.classList.contains('plus')) {
                $this.updateQuantity(itemId, 1);
            }
            });
        });  
        var counter = 0;
        if(this.cartJson[this.currentDate] && this.cartJson[this.currentDate]['counter'] != null){
            counter = this.cartJson[this.currentDate]['counter'];
        }

        // if(this.is_saving){
        //     document.querySelector(".total_order_amount_btn .original").classList.remove("hide");
        //     document.querySelector(".mobile_order_summary_cont .total_order_amount_btn .original").classList.remove("hide");
        // }else{
        //     document.querySelector(".total_order_amount_btn .original").classList.add("hide");
        //     document.querySelector(".mobile_order_summary_cont .total_order_amount_btn .original").classList.add("hide");
        // }
        
        // document.querySelector(".order_counter").textContent = "("+counter+")";

        this.updateCounters();
        this.bindCartEvents();
        this.isSingleDayDelivery();  
        this.updateOrderSummary();
        this.updateDeliveryWindow();
    }

    formatWeekDates(start, dayName) {
        if(document.querySelector('body.limited-menu')){
            var options = { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' };
        }else{
            var options = { weekday: 'long', month: 'short', day: 'numeric', timeZone: 'UTC' };
        }
    
        // Helper function to add ordinal suffix to the day
        const addOrdinalSuffix = (dateString) => {
            return dateString.replace(/(\d+)(?=\s)/, (day) => {
                const lastDigit = day % 10;
                const suffix =
                    lastDigit === 1 && day !== 11
                        ? 'st'
                        : lastDigit === 2 && day !== 12
                        ? 'nd'
                        : lastDigit === 3 && day !== 13
                        ? 'rd'
                        : 'th';
                return `${day}${suffix}`;
            });
        };
    
        // Find the date for the given day name
        const getDateForDayName = (start, dayName) => {
            const startDate = new Date(start);
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const startDayIndex = 0; // Assuming start is always Sunday
            const targetDayIndex = daysOfWeek.indexOf(dayName);
    
            if (targetDayIndex === -1) {
                throw new Error(`Invalid day name: ${dayName}`);
            }
    
            // Calculate the difference in days and adjust the date
            const diff = targetDayIndex - startDayIndex;
            const targetDate = new Date(startDate);
            targetDate.setDate(startDate.getDate() + diff);
    
            return addOrdinalSuffix(targetDate.toLocaleDateString('en-US', options));
        };
    
        return getDateForDayName(start, dayName);
    }

    updateDeliveryWindow(){
        this.getFirstDay();

        let temp_json = JSON.parse(localStorage.getItem("cartJSON") || '{}');
        this.cartJson = Object.keys(temp_json).length > 0 ? temp_json : this.cartJson;

        this.cartJson = this.sortDaysInJSON(this.cartJson);
        this.deliveryWindow = this.deliveryScheduleModal.querySelector(".delivered-date.meal");

        let deliveryDate = new Date(this.currentDate);
        //let options = { month: 'short', day: 'numeric' };
        let options = { weekday: 'short', day: 'numeric', timeZone: 'UTC' };
        let formattedDate = deliveryDate.toLocaleDateString('en-US', options);
        let selectedDate = this.formatWeekDates(this.startDate, this.firstDay);
        this.deliveryWindow.querySelector(".h5").textContent = selectedDate + '.';
                
        this.updateDeliveryTimes(this.firstDay);
        this.newDeliveryDays();
        this.editDeliveryDays();        

        if(this.cartJson[this.currentDate] && this.cartJson[this.currentDate][this.firstDay]){
            if(this.deliveryScheduleOuter){this.deliveryScheduleOuter.parentElement.classList.remove("hide");}
            this.deliveryWindow.querySelector(".time").textContent = this.cartJson[this.currentDate][this.firstDay]['delivery_window'];
        }
        if(this.deliveryInfo){this.deliveryInfo.textContent = this.formatWeekDates(this.startDate, this.firstDay);}
    }

    hideDeliveryButton(){
        let status = false;
        if( this.validDays.length == 1 && 
            this.dayWiseTimeSlots[this.currentDay].length == 1){
            status = true;
        }
        if(document.querySelector(".act-delivery-schedule-outer .act-delivery-schedule")){
            document.querySelector(".act-delivery-schedule-outer .act-delivery-schedule").classList.remove("hide");
            if(status){
                document.querySelector(".act-delivery-schedule-outer .act-delivery-schedule").classList.add("hide");
            }
        }
        
    }

    updateDeliveryTimes(dayName){
        let timeSlots = this.dayWiseTimeSlots[dayName];
        let parent = document.querySelector(".edit-delivery-wrapper.select-time .custom-select .select-items");
        
        let slots = [];
        timeSlots.forEach((timeSlot) => {
            slots.push(`<div class="items" onclick="select_items2(this)">${timeSlot}
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <path d="M1.5 7.78578L3.75 10.0358L10.5 2.96436" stroke="black" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>`);
        });
        parent.innerHTML = slots.join('');
    }

    updateDeliveryNote(note){
        this.deliveryNote = note;
    }

    getFirstDay(){
        let days = this.validDays;
        let day = '';        
        days.forEach((dayName) => {
            if( day == '' && 
                this.cartJson[this.currentDate] != null && 
                this.cartJson[this.currentDate][dayName] != null){
                day = dayName;
            }
        }); 
        
        if(day == ''){
            this.firstDay = this.validDays[0];
            this.cartJson = this.getCartObject();
        }

        return day;
    }

    getDateOfTargetDay(inputDate, targetDay) {
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const date = new Date(inputDate + ' 00:00:00');
        if (isNaN(date)) {
            throw new Error("Invalid date format. Use 'YYYY-MM-DD'.");
        }
        const targetDayIndex = daysOfWeek.indexOf(targetDay);
        if (targetDayIndex === -1) {
            throw new Error("Invalid day of the week. Use full names like 'Monday'.");
        }

        const currentDayIndex = date.getDay();
        const dayDifference = (targetDayIndex - currentDayIndex + 7) % 7;

        const targetDate = new Date(date);
        targetDate.setDate(date.getDate() + dayDifference);

        var storeMonth = targetDate.getMonth()+1;
        storeMonth = storeMonth > 9 ? storeMonth : '0' + storeMonth;
        var storeDate = targetDate.getDate();
        storeDate = storeDate > 9 ? storeDate : '0' + storeDate;
        const formattedDate = `${targetDate.getFullYear()}-${storeMonth}-${storeDate}`;
        // const formattedDate = targetDate.toISOString().split("T")[0];

        return formattedDate;
    }

    newDeliveryDays(){
        let addDeliveryDays = this.deliveryWindowInner.querySelector(".selected-delivery.delivery-add.delivery-form .edit-delivery-wrapper .custom-select .select-items");
        addDeliveryDays.innerHTML = '';

        let content = this.deliveryWindowInner.querySelector(".offer-delivery-box .delivery-days");
        content.innerHTML = '';
        if(document.querySelector('.step1-02-delivery-date')){document.querySelector('.step1-02-delivery-date').innerHTML = '';}
        let counter = 0;
        let temp_json = JSON.parse(localStorage.getItem("cartJSON") || '{}');
        this.cartJson = Object.keys(temp_json).length > 0 ? temp_json : this.cartJson;
        this.validDays.forEach((dayName) => {
            if( this.cartJson[this.currentDate] != null && 
                this.cartJson[this.currentDate][dayName] != null){
                let dayDate = this.getDateOfTargetDay(this.currentDate, dayName);
                content.insertAdjacentHTML('beforeend', 
                    `<div class="selected-delivery selected-delivery-daytime" data-day="${dayName}" data-date="${dayDate}">
                        <span class="day">${dayName}s</span>
                        <span class="time">${this.cartJson[this.currentDate][dayName]['delivery_window']} 
                            <span class="edit-icon" onclick="editDays(this)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 16.6662H17.5M13.75 2.9162C14.0815 2.58468 14.5312 2.39844 15 2.39844C15.2321 2.39844 15.462 2.44416 15.6765 2.533C15.891 2.62184 16.0858 2.75205 16.25 2.9162C16.4142 3.08036 16.5444 3.27523 16.6332 3.48971C16.722 3.70418 16.7678 3.93406 16.7678 4.1662C16.7678 4.39835 16.722 4.62822 16.6332 4.8427C16.5444 5.05718 16.4142 5.25205 16.25 5.4162L5.83333 15.8329L2.5 16.6662L3.33333 13.3329L13.75 2.9162Z" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <span class="close-icon" onclick="removeDays(this)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M14 2L2 14M2 2L14 14" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </span>
                    </div>`);

                    if(document.querySelector('.step1-02-delivery-date')){
                        document.querySelector('.step1-02-delivery-date').insertAdjacentHTML('beforeend', 
                            `<div class="additional_detail">
                                <div class="h3 delivery-day">${dayName}</div>
                                <div class="h3 delivery-date">${new Date(dayDate).toLocaleString('default', { month: 'long' })} ${new Date(dayDate).getDate()}</div>            
                            </div>`);
                    }
                    
                
                addDeliveryDays.insertAdjacentHTML('beforeend',
                    `<div onclick="select_items(this)" class="items selected">${dayName} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M1.5 7.78578L3.75 10.0358L10.5 2.96436" stroke="black" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>`);
                counter++;
            }else{
                addDeliveryDays.insertAdjacentHTML('beforeend',
                    `<div onclick="select_items(this)" class="items">${dayName} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M1.5 7.78578L3.75 10.0358L10.5 2.96436" stroke="black" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>`);
            }
        });

        let newDeliveryButton = this.deliveryWindowInner.querySelector(".selected-delivery.add-delivery");
        newDeliveryButton.classList.remove("hide");
        if(counter == this.validDays.length){
            newDeliveryButton.classList.add("hide");
        }

        let deliveryOffer = this.deliveryWindowInner.querySelector(".otr-deliver-offer");
        deliveryOffer.classList.remove("multiple-delivery");
        if(counter > 1){
            deliveryOffer.classList.add("multiple-delivery");
        }
    }

    editDeliveryDays(){
        let editDeliveryDays = this.deliveryWindowInner.querySelector(".selected-delivery.edit-delivery.delivery-form .edit-delivery-wrapper .custom-select");
        editDeliveryDays.querySelector('.select-selected').innerText = this.firstDay;

        editDeliveryDays = editDeliveryDays.querySelector('.select-items');
        editDeliveryDays.innerHTML = '';

        let counter = 0;
        this.validDays.forEach((dayName) => {
            if( this.cartJson[this.currentDate] != null && 
                this.cartJson[this.currentDate][dayName] != null){                
                    editDeliveryDays.insertAdjacentHTML('beforeend',
                    `<div onclick="select_items(this)" class="items selected">${dayName} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M1.5 7.78578L3.75 10.0358L10.5 2.96436" stroke="black" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>`);
                counter++;
            }else{
                editDeliveryDays.insertAdjacentHTML('beforeend',
                    `<div onclick="select_items(this)" class="items">${dayName} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M1.5 7.78578L3.75 10.0358L10.5 2.96436" stroke="black" stroke-opacity="0.2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>`);
            }
        });
    }

    updateOrderSummary(){
        if( this.cartJson[this.currentDate] && 
            this.cartJson[this.currentDate][this.currentDay]){
            
            var subtotal = this.cartJson[this.currentDate][this.currentDay]['total_price'];
            var savings = this.cartJson[this.currentDate][this.currentDay]['savings'];
            var tax = this.cartJson[this.currentDate][this.currentDay]['tax'];
            var total = this.cartJson[this.currentDate][this.currentDay]['grand_total'];
            var order_total = this.cartJson[this.currentDate]['order_total'];
            var org_total = this.cartJson[this.currentDate][this.currentDay]['grand_total_org'];

            let minOrderAmount = parseFloat(localStorage.getItem("minOrderAmount"));
            //document.querySelector(".minimal-order")

            var percentage = (subtotal / minOrderAmount) * 100;
            if(percentage > 100){
                percentage = 100;
            }

            var bars = document.querySelectorAll(".minimal-order-progress.minimal-order");
            bars.forEach((bar) => {
                bar.style.background = 'linear-gradient(90deg,#dbeee0 '+percentage+'%,#fafafa 0%)';
                var diff = this.formatNumber(minOrderAmount - subtotal);
                bar.querySelector(".min-amount").textContent = '$' + diff;
                bar.classList.remove("hide");
                bar.classList.remove("hide");
                if(parseFloat(subtotal) >= minOrderAmount){
                    bar.classList.add("hide");
                }
            });            
                        
            if(parseFloat(order_total) >= minOrderAmount){
                document.querySelector(".min-order-lmt").classList.remove("hide");
                document.querySelector(".desk-summary .checkout_prices").classList.remove("mgtop");
                document.querySelector(".mobile_order_summary_cont .total_order_amount").classList.remove("hide");
                document.querySelector(".mobile_order_summary_cont .meal_orders_cont.empty-hide").classList.remove("hide");
                document.querySelector(".total_order_amount_btn > h2").textContent = "ORDER NOW";
            }else{
                document.querySelector(".min-order-lmt").classList.add("hide");
                document.querySelector(".desk-summary .checkout_prices").classList.add("mgtop");
                document.querySelector(".mobile_order_summary_cont .total_order_amount").classList.add("hide");
                document.querySelector(".mobile_order_summary_cont .meal_orders_cont.empty-hide").classList.add("hide");
                document.querySelector(".total_order_amount_btn > h2").textContent = "YOUR ORDER";
            }            

            // this.orderSummary.querySelector(".detailed_order_amount .meals-total > h3").textContent = '$' + this.formatNumber((parseFloat(subtotal) + parseFloat(savings)));
            // this.orderSummary.querySelector(".detailed_order_amount .weekly-saving > h3").textContent = '- $' + savings;
            // this.orderSummary.querySelector(".detailed_order_amount .delivery-day-fee > p").textContent = this.currentDay + ' Delivery Fee';
            // this.orderSummary.querySelector(".detailed_order_amount .delivery-day-fee").classList.remove("active");
            // if(this.cartJson[this.currentDate]['order_tax'] == 0){
            //     this.orderSummary.querySelector(".detailed_order_amount .delivery-day-fee").classList.add("active");
            //     this.orderSummary.querySelector(".detailed_order_amount .delivery-day-fee > h3").textContent = 'FREE';
            // }else{
            //     this.orderSummary.querySelector(".detailed_order_amount .delivery-day-fee > h3").textContent = '$' + this.formatNumber(this.cartJson[this.currentDate]['order_tax']/2);
            // }
            
            // this.orderSummary.querySelector(".summary_plus2week_subtotal > h3").textContent = '$' + this.formatNumber(subtotal);

              // Render per-day subtotals for every delivery day that has items.
            // Previously only the currently selected day's subtotal was shown here,
            // which confused customers when the grand total below included items
            // from other days (e.g. Sunday tab showed $50 but Total said $120).

            const allDaysContainer = this.orderSummary.querySelector(".all-days-subtotals");
            if(allDaysContainer){
                allDaysContainer.innerHTML = '';
                const daysWithItems = [];
                Object.keys(this.cartJson[this.currentDate]).forEach((day) => {
                    if(!this.dayKeys.includes(day) &&
                       this.cartJson[this.currentDate][day].lineItems &&
                       this.cartJson[this.currentDate][day].lineItems.length > 0){
                        daysWithItems.push(day);
                    }
                });
                this.sortDays(daysWithItems).forEach((day) => {
                    const daySubtotal = this.cartJson[this.currentDate][day]['total_price'];
                    const isActive = (day === this.currentDay) ? ' active' : '';
                    allDaysContainer.insertAdjacentHTML('beforeend',
                        `<div class="day-subtotal-row${isActive}">
                            <p>${day} Subtotal</p>
                            <h3>$${this.formatNumber(daySubtotal)}</h3>
                        </div>`);
                });
            }




            this.orderSummary.querySelector(".checkout_prices .meals-total > h3").textContent = '$' + this.formatNumber(this.cartJson[this.currentDate]['meals_total']);            
            this.orderSummary.querySelector(".checkout_prices .weekly-saving > h3").textContent = '- $' + this.formatNumber(this.cartJson[this.currentDate]['order_saving']);
            if(this.cartJson[this.currentDate]['order_tax'] > 0){
                this.orderSummary.querySelector(".checkout_prices .delivery-tax > h3").textContent = '$' + this.cartJson[this.currentDate]['order_tax'];
            }else{
                this.orderSummary.querySelector(".checkout_prices .delivery-tax > h3").textContent = 'FREE';
            }

            // console.log("this.promoDiscountAmount: ", this.cartJson[this.currentDate]);
            this.orderSummary.querySelector(".checkout_prices .total_amount_number > .discount").textContent = '$' + this.formatNumber(this.cartJson[this.currentDate]['order_total'] + this.cartJson[this.currentDate]['order_tax'] - this.promoDiscountAmount);                        
            document.querySelector(".mobile_order_summary_cont .total_order_amount_btn .discount").textContent = '$' + this.formatNumber(this.cartJson[this.currentDate]['order_total'] + this.cartJson[this.currentDate]['order_tax'] - this.promoDiscountAmount);
            document.querySelector(".total_amount > .total_amount_number").textContent = '$' + this.formatNumber(this.cartJson[this.currentDate]['meals_total'] + this.cartJson[this.currentDate]['order_tax'] - this.cartJson[this.currentDate]['order_saving']);
            // document.querySelector(".mobile_order_summary_cont .total_order_amount_btn .original").textContent = '$' + org_total;

            this.orderSummary.querySelector(".total_order_amount .total_order_amount_btn").classList.remove("active");
            document.querySelector(".mobile_order_summary_cont .total_order_amount_btn").classList.remove("active");

            var countDays = 0;
            var countitems = 0;
            for(var y=0;y<this.validDays.length;y++){
                if(this.cartJson[this.currentDate][this.validDays[y]].lineItems.length > 0 && this.cartJson[this.currentDate][this.validDays[y]].is_active == false){
                    countDays++;
                    this.orderSummary.querySelector(".total_order_amount .total_order_amount_btn").setAttribute('day',this.validDays[y]);
                    document.querySelector(".mobile_order_summary_cont .total_order_amount_btn").setAttribute('day',this.validDays[y]);
                }
                if(this.cartJson[this.currentDate][this.validDays[y]].lineItems.length > 0){
                    countitems++;
                }
            }
            
            let daysCount = Object.keys(this.cartJson[this.currentDate]).length - 5;
            if(countDays == 0 && countitems > 0){
                this.orderSummary.querySelector(".total_order_amount .total_order_amount_btn").classList.add("active");
                document.querySelector(".mobile_order_summary_cont .total_order_amount_btn").classList.add("active");
                if(document.querySelectorAll('.warning-text').length > 0){
                    document.querySelectorAll('.warning-text').forEach((warning_text) => {
                        warning_text.remove();
                    })
                }
            }

            // if(this.cartJson[this.currentDate][this.currentDay]['is_active']){
            //     this.orderSummary.querySelector(".total_order_amount .total_order_amount_btn").classList.add("active");
            //     document.querySelector(".mobile_order_summary_cont .total_order_amount_btn").classList.add("active");
            // }
            this.orderSummary.classList.remove("hide");
            var savingElms = document.querySelectorAll(".eweekly-saving");
            document.querySelector(".onetime-text").classList.remove('hide');
            document.querySelector(".subscription-text").classList.add('hide');
            document.querySelector(".deliver-text").classList.add('hide');
            if(this.is_saving){
                document.querySelector(".onetime-text").classList.add('hide');
                document.querySelector(".subscription-text").classList.remove('hide');
                document.querySelector(".deliver-text").classList.remove('hide');
            }
            savingElms.forEach((savingElm) => {
                savingElm.classList.add("hide");
                if(this.is_saving){
                    savingElm.classList.remove("hide");
                }
            });
        }else{
            this.orderSummary.classList.add("hide");
        }
    }

    bindOnSubmit(){
        // let $this = this;
        let $json = JSON.parse(localStorage.getItem("cartJSON") || '{}');
        let $this = this;
        let buttons = document.querySelectorAll(".total_order_amount_btn");

        buttons.forEach((button) => {
            button.addEventListener('click', function (event) {
                console.log('click in')
                if(button.classList.contains("active")){
                    console.log('if')
                    // if(document.querySelectorAll('.warning-text').length > 0){
                    //     document.querySelectorAll('.warning-text').forEach((warning_text) => {
                    //         warning_text.remove();
                    //     })
                    // }
 // ── INCOMPLETE WEEK CHECK ──────────────────────────────
                    const skipKeys = ['counter', 'meals_total', 'order_total', 'order_saving', 'order_tax'];
                    const currentWeekCart = $this.cartJson[$this.currentDate];
                    const filledDays = [];
                    const emptyDays = [];

                    if(currentWeekCart){
                        $this.validDays.forEach(function(dayName){
                            if(currentWeekCart[dayName] != null){
                                if(currentWeekCart[dayName].lineItems && currentWeekCart[dayName].lineItems.length > 0){
                                    filledDays.push(dayName);
                                } else {
                                    emptyDays.push(dayName);
                                }
                            }
                        });
                    }

                    // Show popup only when some days have meals and some are empty
                    if(filledDays.length > 0 && emptyDays.length > 0){
                        OTRIncompleteWeekPopup.show({
                            filledDays: filledDays,
                            emptyDays: emptyDays,
                            onAddDay: function(targetDay){
                                // Switch to the empty day tab (desktop)
                                var targetLi = document.querySelector(
                                    '.desk-summary .order__week-daysname .days[data-day="' + targetDay + '"]'
                                );
                                if(targetLi){
                                    targetLi.click();
                                }
                                // Also switch on mobile
                                var targetLiMobile = document.querySelector(
                                    '.mobile_order_summary_cont .order__week-daysname .days[data-day="' + targetDay + '"]'
                                );
                                if(targetLiMobile){
                                    targetLiMobile.click();
                                }
                            },
                            onCheckout: function(){
                                // Proceed with original checkout flow
                                // if(window.innerWidth > 480){
                                //     button.classList.add("text-center");
                                //     button.querySelectorAll('.inner_text').forEach(function(btn){
                                //         btn.classList.add('hidden');
                                //     });
                                //     button.querySelector('.loading__spinner').classList.remove('hidden');
                                // }



button.classList.add("text-center");
button.querySelectorAll('.inner_text').forEach((btn) =>{
    btn.classList.add('hidden');
});
button.querySelector('.loading__spinner').classList.remove('hidden');



                                new SlideoutCartMenu(
                                    $this.cartJson,
                                    $this.currentDate,
                                    $this.currentDay,
                                    $this.fullDate,
                                    $this.startDate,
                                    $this.endDate,
                                    $this.is_saving
                                );
                            }
                        });
                        return; // Stop here — let popup decide what happens next
                    }
                    // ── END INCOMPLETE WEEK CHECK ──────────────────────────

                    // No empty days — proceed directly to checkout









                    if(window.innerWidth > 480){
                        button.classList.add("text-center");
                        button.querySelectorAll('.inner_text').forEach((btn) =>{
                            btn.classList.add('hidden');
                        })
                        button.querySelector('.loading__spinner').classList.remove('hidden');
                    }
                    new SlideoutCartMenu($this.cartJson, $this.currentDate, 
                        $this.currentDay, $this.fullDate, $this.startDate, 
                        $this.endDate, $this.is_saving);
                }else{
                    console.log('else')
                    var get_day = button.getAttribute('day');
                    if(document.querySelectorAll('.warning-text').length > 1){
                        document.querySelectorAll('.warning-text').forEach((warning_text) => {
                            warning_text.remove();
                        })
                        var text = document.createElement('span');
                        text.className = "warning-text";
                        text.textContent = "minimum order not met on " + get_day;
                        text.style.cssText = `
                            color: red; 
                            font-size: 12px;
                            text-transform: capitalize;
                            text-align: center;
                            width: 100%;
                        `;
                        document.querySelector('.summary.desk-summary .total_order_amount').insertAdjacentElement( 'beforeBegin', text );
                        document.querySelector(".mobile_order_summary_cont .total_order_amount").insertAdjacentElement( 'beforeBegin', text.cloneNode(true) );
                    }else{
                        if(document.querySelectorAll('.warning-text').length > 0){
                            document.querySelector('.warning-text').remove();
                        }
                        var text2 = document.createElement('span');
                        text2.className = "warning-text";
                        text2.textContent = "minimum order not met on " + get_day;
                        text2.style.cssText = `
                            color: red; 
                            font-size: 12px;
                            text-transform: capitalize;
                            text-align: center;
                            width: 100%;
                        `;
                        document.querySelector('.summary.desk-summary .total_order_amount').insertAdjacentElement( 'beforeBegin', text2 );
                        document.querySelector(".mobile_order_summary_cont .total_order_amount").insertAdjacentElement( 'beforeBegin', text2.cloneNode(true) );
                    }
                }            
            });
        });
    }

    updateQuantity(itemId, change) {
      var cartData = this.cartJson;
      
      const lineItems = cartData[this.currentDate][this.currentDay].lineItems;
      const item = lineItems.find(i => i.id == itemId);

      if (item) {
          item.quantity = Math.max(1, item.quantity + change);
          this.addOrUpdateCart(item, false);
          return;
      }
    }

    init() {
        this.renderSchedule();
        this.renderHeading(0);
        this.renderAllCollections(0);
        this.renderMeals(0);        
        this.handleCustomEvents();
    

        var $this = this;
        document.addEventListener('click', function (event) {
          if (event.target.matches('.selected.meal_selection_price .quantity')) {
              event.stopPropagation();

              var qtyButton = event.target;
              var parent = qtyButton.closest(".selected.meal_selection_price").querySelector(".meal_count");
              
              var quantity = parseInt(parent.innerHTML.trim());
              var get_day = 'data-' + document.querySelector('.desk-summary .order__week-daysname li.active').dataset.day;
              if(parent.getAttribute(get_day) == null){
                parent.setAttribute(get_day,1);
              }
              
              if(qtyButton.dataset.action == "plus"){
                parent.setAttribute(get_day,(parseInt(parent.getAttribute(get_day)) + 1));
                if(qtyButton.closest('.builder_meals_cont')){
                 quantity++;
                 if(quantity == 1){
                   qtyButton.closest('.meal_selection_price').querySelector('.quantity.qty').classList.remove('hide');
                   qtyButton.closest('.meal_selection_price').querySelector('.quantity[data-action="minus"]:not(.qty)').classList.add('hide');
                 }else{
                   qtyButton.closest('.meal_selection_price').querySelector('.quantity.qty').classList.add('hide');
                   qtyButton.closest('.meal_selection_price').querySelector('.quantity[data-action="minus"]:not(.qty)').classList.remove('hide');
                 }
                }else{
                  quantity++;
                }
              }else {
                parent.setAttribute(get_day,(parseInt(parent.getAttribute(get_day)) - 1));
                if(qtyButton.closest('.builder_meals_cont')){
                 quantity--; 
                 if(quantity == 1){
                   qtyButton.closest('.meal_selection_price').querySelector('.quantity.qty').classList.remove('hide');
                   qtyButton.closest('.meal_selection_price').querySelector('.quantity[data-action="minus"]:not(.qty)').classList.add('hide');
                 }
                }else{
                  quantity--;  
                }
              }

              if(quantity < 1){
                quantity = 1;
              }
              parent.innerHTML = quantity.toString();

              var product = JSON.parse(qtyButton.closest(".meal").dataset.product);
              var qunatityNew = parent.getAttribute(get_day);
            //   product['quantity'] = quantity;
              product['quantity'] = quantity;
              $this.addOrUpdateCart(product, false);
          }
        });

        this.filterButton.addEventListener('click', () => {
            // this.renderAllCollections(index);
          document.querySelector(".slideout-sec.add_filter").classList.add("active");
        });

        document.addEventListener('click', function(event) {
            if (event.target && event.target.matches('.can.delete')) {
                const itemId = event.target.dataset.id;
                const lineItems = $this.cartJson[$this.currentDate][$this.currentDay]['lineItems'];
                const item = lineItems.find(i => i.id == itemId);
                $this.addOrUpdateCart(item, true);
                
                let elms = document.querySelectorAll(".builder_meals_cont .meal[data-id='"+itemId+"']");
                elms.forEach((elm) => {
                    elm.querySelector(".unselected.meal_selection_price").classList.remove("hide");
                    elm.querySelector(".selected.meal_selection_price").classList.add("hide");
                    if(elm.querySelector(".meal_count")){elm.querySelector(".meal_count").textContent = "1";}
                    var get_day = 'data-' + document.querySelector('.desk-summary .order__week-daysname li.active').dataset.day;
                    if(elm.querySelector(".meal_count")){elm.querySelector(".meal_count").setAttribute(get_day,1);}
                });
            }
        });
        
    }

    handleCustomEvents(){
        let $this = this;
        document.body.addEventListener('mealChangeEvent', function(event) {
            // console.log("event.detail: ", event.detail);
            let data = event.detail;
            switch (data.type) {
                case "addDay":
                    $this.addDeliveryDay(data.data.day);
                    break;
                case "removeDay":
                    $this.removeDeliveryDay(data.data.day);
                    break;
                case "changeDayTime":
                    $this.changeDeliveryDayTime(data.data.newDay, data.data.oldDay, data.data.dayTime);
                    break;
                default:
                    break;
            }            
        });
    }

    sortDaysInJSON(jsonData) {
        const dayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      
        Object.keys(jsonData).forEach(dateKey => {
          let dayEntries = jsonData[dateKey];
          
          let days = Object.keys(dayEntries).filter(key => dayOrder.includes(key));
          days.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));

          let sortedDayEntries = {};
          days.forEach(day => {
            sortedDayEntries[day] = dayEntries[day];
          });
      
          Object.keys(dayEntries).forEach(key => {
            if (!dayOrder.includes(key)) {
              sortedDayEntries[key] = dayEntries[key];
            }
          });
      
          jsonData[dateKey] = sortedDayEntries;
        });
      
        return jsonData;
    }

    addDeliveryDay1(dayName){
        let value = dayName;
        let $this = this;
        if(value != null && value != '' && $this.validDays.includes(value)){
            $this.cartJson[$this.currentDate][value] = {
                'lineItems': [], 
                'counter': 0, 
                'total_price': 0, 
                'total_compare_price': 0, 
                'savings': 0, 
                'tax': parseFloat($this.currentZone['delivery_amount']),
                'grand_total': 0,
                'grand_total_org': 0,
                'is_active': false,
                'delivery_window': $this.dayWiseTimeSlots[value][0],
                'full_date': $this.fullDate
            };
            // $this.applyWeekDayChanges(value);
            localStorage.setItem("cartJSON", JSON.stringify($this.cartJson));
            setWithExpiry('cartData', 3);
            $this.cartJson = $this.getCartObject();
            $this.updateDeliveryWindow();
            $this.renderCart();
            $this.bindCartEvents();
        }            
    }

    addDeliveryDay(dayName){
        let value = dayName;
        let $this = this;
        if(value != null && value != '' && $this.validDays.includes(value)){
            const currentWeekData = $this.data.find(week => week.start_date === $this.currentDate);    
            if (currentWeekData && currentWeekData.delivery_days.includes(value)) {

                if (!$this.cartJson[$this.currentDate]) {
                    $this.cartJson[$this.currentDate] = {'counter': 0};
                }
                if (!$this.cartJson[$this.currentDate][value]) {
                    $this.cartJson[$this.currentDate][value] = {
                        'lineItems': [], 
                        'counter': 0, 
                        'total_price': 0, 
                        'total_compare_price': 0, 
                        'savings': 0, 
                        'tax': parseFloat($this.currentZone['delivery_amount']),
                        'grand_total': 0,
                        'grand_total_org': 0,
                        'is_active': false,
                        'delivery_window': currentWeekData.daywise_timeslots[value]?.[0] || '',
                        'full_date': $this.fullDate
                    };
                }
            }
    
            localStorage.setItem("cartJSON", JSON.stringify($this.cartJson));
            setWithExpiry('cartData', 3);
            $this.cartJson = $this.getCartObject();
            $this.updateDeliveryWindow();
            $this.renderCart();
            $this.bindCartEvents();
        }            
    }    

    removeDeliveryDay(dayName){
        let $this = this;
        if(dayName != null && dayName != '' && $this.validDays.includes(dayName)){
            
            $this.data.forEach((currentItem) => {
                if($this.cartJson[currentItem['start_date']] != null){
                    if( currentItem.start_date == $this.currentDate ){
                        Object.keys($this.cartJson[currentItem['start_date']]).forEach((day) => {
                            if(!this.dayKeys.includes(day) && day == dayName){
                                delete $this.cartJson[currentItem['start_date']][dayName];
                            }
                        });
                    }
                }          
            });

            $this.firstDay = $this.getFirstDay();
            localStorage.setItem("cartJSON", JSON.stringify($this.cartJson));
            setWithExpiry('cartData', 3);
            $this.cartJson = $this.getCartObject();
            $this.updateDeliveryWindow();
            $this.renderCart();
            $this.bindCartEvents();
        }            
    }

    changeDeliveryDayTime(dayName, oldDayName, dayTime){
        let days = [];
        this.data.forEach((currentItem) => {
            if(this.cartJson[currentItem['start_date']] != null){
              Object.keys(this.cartJson[currentItem['start_date']]).forEach((day) => {
                  if(!this.dayKeys.includes(day)){
                    days.push(day);
                  }
              });
            }          
        });

        if( oldDayName != null && 
            oldDayName != '' && 
            oldDayName != dayName  && 
            days.length != this.validDays.length){
            this.addDeliveryDay(dayName);
            this.removeDeliveryDay(oldDayName);
        }
        
        this.data.forEach((currentItem) => {
            if(this.cartJson[currentItem['start_date']] != null){
                Object.keys(this.cartJson[currentItem['start_date']]).forEach((day) => {
                    if(!this.dayKeys.includes(day) && day == dayName){
                        this.cartJson[currentItem['start_date']][dayName]['delivery_window'] = dayTime;
                    }
                });
            }          
        });

        localStorage.setItem("cartJSON", JSON.stringify(this.cartJson));
        setWithExpiry('cartData', 3);
        this.cartJson = this.getCartObject();
        this.updateDeliveryWindow();
        this.renderCart();
        this.bindCartEvents();
    }

    renderSchedule() {
        this.container.innerHTML = '';

        this.data.forEach((item, index) => {
            if(index > 1){
                return;
            }
            const button = this.createScheduleButton(item, index);
            this.container.appendChild(button);
            
            if( (index + 1) >= 2 ){                
                var has_week_date = localStorage.getItem('weekDate');
                if( has_week_date != null ){
                    has_week_date = JSON.parse(has_week_date);
                    setTimeout(function(){
                        document.querySelector('.selector_buttons_cont .selector_btn_outer[data-start-date="'+has_week_date.start_data+'"]').click();                        
                    },290);
                    localStorage.removeItem("weekDate");
                    localStorage.setItem("weekDateRemoved",'');
                }
            }            
        });        

        if(this.deliveryInfo){
            this.deliveryInfo.textContent = this.firstDay;
        }
        
        this.modalEventsBinding();            
    }

    createScheduleButton(item, index) {
        const { start_date, end_date, delivery_days } = item;

        const fromDate = new Date(start_date).toLocaleString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC'  });
        const toDate = end_date ? new Date(end_date).toLocaleString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }) : '';

        const button = document.createElement('div');
        button.className = `swiper-slide selector_btn_outer ${index === 0 ? 'active' : ''}`;
        button.setAttribute('data-index',index);
        
        const buttonInner = document.createElement('div');
        
        buttonInner.className = `selector_btn`;
        buttonInner.innerHTML = `
            <h2 class="from_date">${fromDate}</h2>
            <h2 class="to_date">- ${toDate}</h2>
        `;
        
        // button.className = `selector_btn ${index === 0 ? 'active' : ''}`;
        button.dataset.startDate = start_date;
        button.dataset.endDate = end_date;        

        button.appendChild(buttonInner);

        button.addEventListener('click', () => {
        //   console.log('1');
            this.updateActiveButton(button);
            if(this.deliveryInfo){
                this.deliveryInfo.textContent = this.firstDay;
            }
            this.renderHeading(index);
            this.renderAllCollections(index);
            this.renderMeals(index);
            this.updateCurrentDates(button);
        });

        return button;
    }

    updateCurrentDates(button){
        let start_date = button.dataset.startDate;
        let end_date = button.dataset.endDate;
        // let selected_index = button.dataset.slickIndex;
        let selected_index = button.dataset.index;
        if(selected_index == null || selected_index == '' || selected_index == undefined){
            selected_index = 0;
        }
        this.validDays = this.data[selected_index].delivery_days;
        this.currentDay = this.validDays[0];
        this.firstDay = this.currentDay;
        this.currentDate = start_date;
        this.fullDate = this.formatedStartEndDates(start_date, end_date);
        this.startDate = start_date;
        this.endDate = end_date;      
        this.hideDeliveryButton();

        let days = [];
        Object.keys(this.cartJson[this.currentDate]).forEach((day) => {
            if(!this.dayKeys.includes(day)){
                days.push(day);
            }
        });
        days = this.sortDays(days);
        if(!days.includes(this.firstDay)){            
            this.firstDay = days[0];
            this.currentDay = this.firstDay;
        }

        this.renderCart();
        new SearchFilter(this.data, this.startDate);

        localStorage.setItem('currentDate', this.currentDate);
        localStorage.setItem('currentDay', this.currentDay);
    }

    updateActiveButton(button) {
        this.container.querySelectorAll('.selector_btn_outer').forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
    }

    renderHeading(index) {
        const { start_date, end_date } = this.data[index];
        // const fromDate = new Date(start_date).toLocaleString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
        // const toDate = end_date ? new Date(end_date).toLocaleString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }) : '';
        // this.headingContainer.textContent = `${fromDate} - ${toDate} Week Menu`;
        if(document.querySelector('body.limited-menu')){
            var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var monthOfyear = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            if(store_limitd_obj.overDate != ''){
                var customoverDate = new Date(store_limitd_obj.overDate);
                var get_html_date = `${daysOfWeek[customoverDate.getDay()]}, ${monthOfyear[customoverDate.getMonth()]} ${customoverDate.getDate()}`;
                this.headingContainer.textContent = `${get_html_date}`;
            }else{
                var customoverDate = new Date(start_date).toLocaleString('en-US', { weekday:'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
                // var get_html_date = `${daysOfWeek[customoverDate.getDay()]}, ${monthOfyear[customoverDate.getMonth()]} ${customoverDate.getDate()}`;
                this.headingContainer.textContent = `${customoverDate}`;
            }
            // const fromDate = store_limitd_obj.startDate ? new Date(store_limitd_obj.startDate).toLocaleString('en-US', { weekday:'long', month: 'long', day: 'numeric', timeZone: 'UTC' }) : new Date(start_date).toLocaleString('en-US', { weekday:'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
            // this.headingContainer.textContent = `${fromDate}`;
        }else{
            const fromDate = new Date(start_date).toLocaleString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
            const toDate = end_date ? new Date(end_date).toLocaleString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }) : '';
            this.headingContainer.textContent = `${fromDate} - ${toDate} Week Menu`;
        }
    }

    renderAllCollections(index) {
        this.categoryContainer.innerHTML = '';
        this.categoryContainer.appendChild(this.filterButton);

        const collections = this.data[index].collections;

        collections.forEach((collection) => {
            const button = document.createElement('button');
            button.className = 'food_catagory_btns';
            button.textContent = collection;

            button.addEventListener('click', () => {              
                if(button.classList.contains('active')){
                  this.searchFilter.flushAll();
                  this.updateActiveCollectionButton(button);
                  this.renderMeals(index);
                  button.classList.remove('active');
                }else{
                  this.searchFilter.flushAll();
                  this.updateActiveCollectionButton(button);
                  this.renderMeals(index, collection);
                }
                // this.searchFilter.flushAll();
                // this.updateActiveCollectionButton(button);
                // this.renderMeals(index, collection);                
            });

            this.categoryContainer.appendChild(button);
        });
    }

    renderCollections(index) {
        this.categoryContainer.innerHTML = '';
        this.categoryContainer.appendChild(this.filterButton);

        const collections = this.data[index].collections;

        collections.forEach((collection) => {
            const button = document.createElement('button');
            button.className = 'food_catagory_btns';
            button.textContent = collection;

            button.addEventListener('click', () => {
            //   console.log('3');
                this.updateActiveCollectionButton(button);
                this.renderMeals(index, collection);
            });

            this.categoryContainer.appendChild(button);
        });
    }

    renderMeals(index, filterCollection = null) {
    //   console.log('injs');
        this.mealsContainer.innerHTML = '';

        const products = this.data[index].products;
        const collections = this.data[index].collections;

        collections.forEach((collection, collectionIndex) => {
            // if (filterCollection && filterCollection !== collection) {
            //     return;
            // }

            const cataContainer = document.createElement('div');
            cataContainer.className = "meal_catag_containers";
            cataContainer.dataset.collection = collection;
            if(filterCollection && filterCollection !== collection){
                cataContainer.classList.add('hide');
            }            

            const collectionContainer = document.createElement('div');            
            const collectionTitle = document.createElement('h1');
            collectionTitle.textContent = collection;
            collectionContainer.appendChild(collectionTitle);
            cataContainer.appendChild(collectionContainer);

            const mealsContainer = document.createElement('div');
            mealsContainer.className = 'builder_meals_cont';

            const collectionProducts = Object.values(products).filter(product => product.collection === collection);
            var indexer = 1;
            // collectionProducts.forEach(product => {
            //     const mealDiv = this.createMealDiv(product, indexer);
            //     mealsContainer.appendChild(mealDiv);
            //     indexer++;
            // });

            const coll_prod_withrank = [];
            const coll_prod_withnorank = [];

            collectionProducts.forEach(product => {
                if(product.rank != ''){
                    coll_prod_withrank.push(product);
                }
            })

            coll_prod_withrank.sort((a, b) => a.rank - b.rank)
            coll_prod_withrank.sort(function(a, b) {
                var textA = a.title.toUpperCase();
                var textB = b.title.toUpperCase();
                var rankA = a.rank.toUpperCase();
                var rankB = b.rank.toUpperCase();
                if(rankA == rankB){
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                }
            });

            collectionProducts.forEach(product => {
                if(product.rank == ''){
                    coll_prod_withnorank.push(product);
                }
            })

            coll_prod_withnorank.sort(function(a, b) {
                var textA = a.title.toUpperCase();
                var textB = b.title.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            if(coll_prod_withrank.length > 0){
                coll_prod_withrank.forEach(product => {
                    const mealDiv = this.createMealDiv(product, indexer);
                    mealsContainer.appendChild(mealDiv);
                    indexer++;
                });
            }
            
            if(coll_prod_withnorank.length > 0){
                coll_prod_withnorank.forEach(product => {
                    const mealDiv = this.createMealDiv(product, indexer);
                    mealsContainer.appendChild(mealDiv);
                    indexer++;
                });
            }

            cataContainer.appendChild(mealsContainer);
            this.mealsContainer.appendChild(cataContainer);
            this.bindEvents();
            if( collectionIndex == (collections.length - 1) ){
                callYotpo();
              }
        });   
        
         // ✅ FIX 2: Week switch ke baad subscription state correctly apply karo
    this.updateProductCards(this.is_saving);


    }

    bindEvents(){
        let $this = this;
        this.addToCartButtons = this.mealsContainer.querySelectorAll(".unselected.meal_selection_price");
        this.addToCartButtons.forEach(cartbutton => {
            cartbutton.querySelector("img").addEventListener('click', () => {
                
                cartbutton.classList.add("hide");
                cartbutton.closest('.meal_info_cont').querySelector('.selected.meal_selection_price').classList.remove("hide");          

                var product = JSON.parse(cartbutton.closest(".meal").dataset.product);
                product['quantity'] = 1;            
                $this.addOrUpdateCart(product, false);   

                cartbutton.closest('.meal_info_cont').querySelector('.quantity.qty').classList.remove('hide');
                cartbutton.closest('.meal_info_cont').querySelector('.quantity[data-action="minus"]:not(.qty)').classList.add('hide');
            });        
        });

        let buttons = this.mealsContainer.querySelectorAll(".selected.meal_selection_price");
        buttons.forEach(cartbutton => {
            cartbutton.querySelector("img").addEventListener('click', (event) => {
                event.stopPropagation();
                let elm = event.target;
                var product = JSON.parse(cartbutton.closest(".meal").dataset.product);
                if(elm.classList.contains("delete")){
                    $this.addOrUpdateCart(product, true);

                    elm.closest(".meal_info_cont").querySelector(".unselected.meal_selection_price").classList.remove("hide");
                    elm.closest(".meal_info_cont").querySelector(".selected.meal_selection_price").classList.add("hide");
                    elm.closest(".meal_info_cont").querySelector(".meal_count").textContent = "1";
                    var get_day = 'data-' + document.querySelector('.desk-summary .order__week-daysname li.active').dataset.day;
                    if(elm.querySelector(".meal_count")){elm.querySelector(".meal_count").setAttribute(get_day,1);}
                }
            });
        });
    }

    createMealDiv(product, indexer) {
        const mealDiv = document.createElement('div');
        mealDiv.className = 'meal meal' + indexer + ' col-' + product.collection;
        mealDiv.dataset.product = JSON.stringify(product);
        mealDiv.dataset.id = product.id;

        var tagsHTML = [];
        product.tags.forEach((tag) => {
            if(tag.includes("special")){
                tagsHTML.push('<span class="speciality">Special</span>');
            }else if(tag.includes("week_")){
                tagsHTML.push('<span class="week-priority">'+tag.replaceAll("_", " ").replaceAll("tag:", "")+'</span>');
            }else if(tag.includes("save_")){
                tagsHTML.push('<span class="save">'+tag.replaceAll("_", " ").replaceAll("tag:", "")+'%</span>');
            }else if(tag.includes("low_carb")){
                tagsHTML.push('<span class="nutrition-value">Low Carb</span>');
            }
            if(tag.includes("tag:new_product")){
                tagsHTML.push('<span class="new">new</span>');
            }
        });
        tagsHTML = tagsHTML.join('');

        // let priceHTML = `<div>
        //                     <p class="meal_current_price">$${product.price}</p>
        //                     <p class="meal_old_price">$${product.compare_at_price}</p>
        //                 </div>`;
        // if(this.is_saving == false){
        //     priceHTML = `<div>
        //                     <p class="meal_current_price">$${product.compare_at_price}</p>
        //                 </div>`;
        // }

        // console.log("this.is_saving: ", this.is_saving);

// ✅ FIX 1: Hamesha dono prices rakho — CSS + no-sub class handle karti hai display
let priceHTML = `<div>
                    <p class="meal_current_price">$${product.price}</p>
                    <p class="meal_old_price">$${product.compare_at_price}</p>
                </div>`;



        var meal_avail_html = '';
        var stock_value = product.inventory < product.stock ? product.stock : product.inventory;
        if(document.querySelector('body.limited-menu') && product.inventory != "" && product.inventory > 0){
            meal_avail_html = `<div class="meal_available ${product.inventory < product.stock ? 'meal_left' : ''}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                            <circle cx="2.25" cy="3" r="2.25" fill="Currentcolor"></circle>
                            </svg>
                            ${product.inventory < product.stock ? 'Only '+product.inventory+' left!' : product.inventory+' available' }
                        </div>`;
        }

        var macros_data = '';
        var macros_data_html = '';
        if(product.cals != ''){
            macros_data += `<div class="details-tab"><span>Cals</span><span>${product.cals}</span></div>`;
        }
        if(product.protein != ''){
            macros_data += `<div class="details-tab"><span>Protein</span><span>${product.protein}</span></div>`;
        }
        if(product.fats != ''){
            macros_data += `<div class="details-tab"><span>Fat</span><span>${product.fats}</span></div>`;
        }
        if(product.carbs != ''){
            macros_data += `<div class="details-tab"><span>Carbs</span><span>${product.carbs}</span></div>`;
        }

        if(macros_data != ''){
            macros_data_html = `<div class="macros">${macros_data}</div><span class="slide-btn">View More <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5 0.625V9.375M0.625 5H9.375" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
        }
        
        mealDiv.innerHTML = `
            <div class="meal__item-inner">
                <div class="meal_img_cont">
                    <div class="product-tag-wrapper">${tagsHTML}</div>
                    <img src="${product.image}" alt="${product.title}">
                </div>            
                <div class="meal_info_cont">
                    <div class="meal_naming">
                        <div class="meal_rating">
                            <div class="yotpo-widget-instance" data-yotpo-instance-id="979814" data-yotpo-product-id="${product.id}" data-yotpo-cart-product-id="${product.id}" data-yotpo-section-id="index"></div>
                        </div>
                        <h2 class="meal_h2">${product.title}</h2>
                        ${meal_avail_html}
                        ${macros_data_html}
                    </div>
                    <div class="unselected meal_selection_price">
                        ${priceHTML}
                        <img src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/plus.svg?v=1725360083" alt="">
                    </div>
                    <div class="selected meal_selection_price hide">
                        <img class="quantity qty delete hide" data-action="minus" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/dustbin-white.svg?v=1731654430" alt="Delete">
                        <img class="quantity" data-action="minus" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/minus.svg?v=1725360090" alt="">
                        <div>
                            <p class="meal_count">1</p>
                        </div>
                        <img class="quantity" data-action="plus" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/plus.svg?v=1725360083" alt="">
                    </div>
                </div>
            </div>
        `;

        return mealDiv;
    }

    updateActiveCollectionButton(button) {
        this.categoryContainer.querySelectorAll('.food_catagory_btns').forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
    }

    updateOrderHeadingDates(currentItem ='', days = '') {
        const orderHeadingContainer = document.querySelector('.summary.desk-summary .order_heading_container');
        const orderHeadingContainermobile = document.querySelector('.order_heading_container_mobile')
        if (!orderHeadingContainer) return;

        // Hide container by default
        orderHeadingContainer.classList.add('hide');
        if(orderHeadingContainermobile){
            orderHeadingContainermobile.classList.add('hide');
        }

        // Clear existing dates
        const existingDates = orderHeadingContainer.querySelectorAll('.delivery-date-info');
        existingDates.forEach(date => date.remove());
        
        if(orderHeadingContainermobile){
            const existingDates_mobile = orderHeadingContainermobile.querySelectorAll('.delivery-date-info');
            existingDates_mobile.forEach(datemobile => datemobile.remove());
        }

        // Get all selected delivery days from cartJson that have items
        let selectedDates = [];
        if(currentItem != '' && currentItem.start_date){
            this.currentDate = currentItem.start_date;
        }
        if (this.cartJson[this.currentDate]) {
            // Define keys to skip
            const skipKeys = ['counter', 'meals_total', 'order_total', 'order_saving', 'order_tax'];
            
            // Process only day values that have items
            Object.keys(this.cartJson[this.currentDate]).forEach(key => {
                if (!skipKeys.includes(key) && 
                    this.cartJson[this.currentDate][key].lineItems && 
                    this.cartJson[this.currentDate][key].lineItems.length > 0) {
                    selectedDates.push({
                        day: key,
                        date: this.formatWeekDates(this.startDate, key)
                    });
                }
            });
        }

        // Sort dates chronologically
        selectedDates.sort((a, b) => {
            return this.validDays.indexOf(a.day) - this.validDays.indexOf(b.day);
        });

        // Add only one date element based on priority and show container if we have dates
        if (selectedDates.length > 0) {
            
            // const dateElement = document.createElement('div');
            // dateElement.className = 'delivery-date-info';
            // dateElement.textContent = `${selectedDates[0].date}`;
            // const dateElement_mobile = document.createElement('div');
            // dateElement_mobile.className = 'delivery-date-info';
            // dateElement_mobile.textContent = `${selectedDates[0].date}`;
            // orderHeadingContainer.appendChild(dateElement);
            // if(orderHeadingContainermobile){
            //     orderHeadingContainermobile.appendChild(dateElement_mobile);
            // }

            if(document.querySelector('body.limited-menu')){

                var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                var monthOfyear = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                
                if(store_limitd_obj.overDate != ''){
                    var customoverDate = new Date(store_limitd_obj.overDate);
                    var get_html_date = `${daysOfWeek[customoverDate.getDay()]}, ${monthOfyear[customoverDate.getMonth()]} ${customoverDate.getDate()}`;
                    var display_date = `${get_html_date}`;
                }else{
                    var customoverDate = new Date(this.currentDate).toLocaleString('en-US', { weekday:'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
                    // var get_html_date = `${daysOfWeek[customoverDate.getDay()]}, ${monthOfyear[customoverDate.getMonth()]} ${customoverDate.getDate()}`;
                    var display_date = `${customoverDate}`;
                }
                orderHeadingContainer.innerHTML = `<h3>Your Menu for ${display_date}</h3>`;
                if(orderHeadingContainermobile){
                    orderHeadingContainermobile.innerHTML = `<h3>Your Menu for ${display_date}</h3>`;
                }
            }else{
                const dateElement = document.createElement('div');
                dateElement.className = 'delivery-date-info';
                dateElement.textContent = `${selectedDates[0].date}`;
                const dateElement_mobile = document.createElement('div');
                dateElement_mobile.className = 'delivery-date-info';
                dateElement_mobile.textContent = `${selectedDates[0].date}`;
                orderHeadingContainer.appendChild(dateElement);
                if(orderHeadingContainermobile){
                    orderHeadingContainermobile.appendChild(dateElement_mobile);
                }
            }
            
            // Show container only when we have dates to display
            orderHeadingContainer.classList.remove('hide');
            orderHeadingContainermobile.classList.remove('hide');
        }

        let localDeliveryNotes = localStorage.getItem("DeliveryNotes");
        if (localDeliveryNotes) {
            const selectEl = document.querySelector('.dl-note select');
            const targetValue = localDeliveryNotes;
            if (selectEl) {
                for (let opt of selectEl.options) {
                    if (opt.value === targetValue) {
                        opt.selected = true;
                        break;
                    }
                }
            }
        }
        
    }
}

class SlideoutCartMenu {
    constructor(cartJson, currentDate, currentDay, fullDate, startDate, endDate, is_saving) {
        this.cartJson = cartJson[currentDate];
        this.currentDate = currentDate;
        this.currentDay = currentDay;
        this.fullDate = fullDate;
        this.startDate = startDate;
        this.endDate = endDate;
        this.container = document.querySelector(".order-summary-drawer");
        this.subscription = document.querySelector(".summary-drawer-inner .saving #saving");
        this.lineItems = [];
        this.meals_total = 0;
        this.delivery_rate = 0;
        this.meals_weekly_savings = 0;
        this.total_amount = 0;
        this.scheduleObj = null;
        this.is_saving = is_saving;
        this.dayKeys = [];
        this.checkoutCartJson = {
            'lineItems': [],
            'settings': {
                'start_date': '',
                'end_date': '',
                'days': [],
                'notes': '',
                'promo_code': '',
                'postal_code': localStorage.getItem('postal_code'),
                'is_delivery_free': false
            }
        };
        this.init();    
        localStorage.setItem('slideOut', 'cart');
    }

    init(){
        this.scheduleObj = $scheduleRenderer;
        this.setLineItems();
        this.renderCart();
        this.onClose();
        this.bindOnSubmit();

        let $this = this;
        if(!this.scheduleObj.isClickEventBind){
            this.scheduleObj.isClickEventBind = true;
            document.addEventListener('click', function(event) {                        
                if (event.target && event.target.matches('.render.qty')) {
                    
                    $this.scheduleObj.currentDay = event.target.closest(".otr-meal-card").dataset.day;

                    if(event.target.matches('.can.delete')){
                        $this.cartJson = $this.scheduleObj.cartJson[$this.scheduleObj.currentDate];
                    }else{
                        let itemId = event.target.dataset.id;

                        if (event.target.classList.contains('minus')) {
                            $this.scheduleObj.updateQuantity(itemId, -1);
                        } else if (event.target.classList.contains('plus')) {
                            $this.scheduleObj.updateQuantity(itemId, 1);
                        }

                        let lineItems = $this.scheduleObj.cartJson[$this.scheduleObj.currentDate][$this.scheduleObj.currentDay]['lineItems'];
                        let item = lineItems.find(i => i.id == itemId);
                        if(item){
                            event.target.parentElement.querySelector(".inpt-quantity").textContent = item.quantity;
                        }

                        $this.cartJson = $this.scheduleObj.cartJson[$this.scheduleObj.currentDate];                    
                    }
                    setTimeout(function(){
                        $this.setLineItems();
                        $this.renderCart();
                    }, 200);
                }
            });
        }  
        
        let elms = document.querySelectorAll('.saving.menu-b #saving');
        document.querySelectorAll(".saving.sum-draw input").forEach((inner_inputs)=>{
            inner_inputs.addEventListener('click', (event) => {
                event.stopPropagation();

                // document.querySelector(".saving.menu-b #saving").click();

                var get_val = event.target.getAttribute('id');
                if(get_val == 'subscription'){
                    $this.is_saving = false;
                    $this.scheduleObj.is_saving = false;
                }else{
                    $this.is_saving = false;
                    $this.scheduleObj.is_saving = false;
                }
                
                document.querySelector(".saving.menu-b #saving").checked = $this.is_saving;

                elms.forEach((e) => {
                    e.checked = $this.scheduleObj.is_saving;
                });

                $this.scheduleObj.updateProductCards($this.scheduleObj.is_saving);
                $this.scheduleObj.renderCart();
                $this.setLineItems();
                //$this.renderCart();
            })               
        });
    }

    setLineItems(){
        let $this = this;
        
        this.lineItems = [];
        this.meals_total = 0;
        this.delivery_rate = 0;
        this.meals_weekly_savings = 0;
        this.total_amount = 0;
        this.dayKeys = this.scheduleObj.dayKeys;

        Object.keys(this.cartJson).forEach(day => {
            if(day != null && day != '' && !this.dayKeys.includes(day)){
                if(this.cartJson[day]['is_active']){
                    $this.lineItems = $this.lineItems.concat($this.cartJson[day]['lineItems']);
                }
                $this.meals_total += parseFloat($this.cartJson[day]['total_price']);
                $this.meals_weekly_savings += parseFloat($this.cartJson[day]['savings']);                

                if(this.is_saving){
                    $this.delivery_rate += parseFloat($this.cartJson[day]['tax']);
                }else{
                    $this.delivery_rate = parseFloat($this.cartJson[day]['tax']);
                }
                
                $this.total_amount += parseFloat($this.cartJson[day]['grand_total']);
    
                $this.checkoutCartJson['settings']['days'].push({
                    'day_name': day, 
                    'delivery_window': $this.cartJson[day]['delivery_window']
                });
            }            
        });

        this.checkoutCartJson['settings']['start_date'] = this.startDate;
        this.checkoutCartJson['settings']['end_date'] = this.endDate;
        this.checkoutCartJson['lineItems'] = this.lineItems;
    }

    setProgressBar(){
        let meals_threshold = this.cartJson['order_total'];
        let cartSummary = this.container.querySelector(".checkout_prices");
        let elm = cartSummary.querySelector(".meal_orders_cont .progress_bar_cont > p.live-prog");
        cartSummary.querySelector(".promo-discount > span").textContent = `${this.scheduleObj.perDiscountPromo['discount_value']}% Discount`;        
        let elms = cartSummary.querySelectorAll(".all-tiers .oc-free-gift");
        elms.forEach((el) => {
            el.classList.add("hide");
        });

        let freeGiftPromo = -1;
        if(this.scheduleObj.freeGiftPromo['enable']){
            freeGiftPromo = parseFloat(this.scheduleObj.freeGiftPromo['min_trigger_value']);
        }
        let perDiscountPromo = -1;
        if(this.scheduleObj.perDiscountPromo['enable']){
            perDiscountPromo = parseFloat(this.scheduleObj.perDiscountPromo['min_trigger_value']);
        }

        let diff = 0;
        if(this.scheduleObj.isSingleDay){
            if(meals_threshold < this.scheduleObj.currentZone['one_day_free_delivery']){
                diff = this.scheduleObj.formatNumber(this.scheduleObj.currentZone['one_day_free_delivery'] - meals_threshold);
                elm.innerHTML = `Spend <strong>$${diff}</strong> more to get <strong>Free Delivery</strong>`;
            }else if(meals_threshold > this.scheduleObj.currentZone['one_day_free_delivery'] && 
                perDiscountPromo != -1 &&
                meals_threshold < perDiscountPromo
            ){
                cartSummary.querySelector(".free-delivery").classList.remove("hide");                
                diff = this.scheduleObj.formatNumber(perDiscountPromo - meals_threshold);
                elm.innerHTML = `Spend <strong>$${diff}</strong> more to get <strong>Discount Promo</strong>`;
            }else if(meals_threshold > this.scheduleObj.currentZone['one_day_free_delivery'] && 
                freeGiftPromo != -1 &&
                meals_threshold < freeGiftPromo
            ){                
                cartSummary.querySelector(".free-delivery").classList.remove("hide");
                cartSummary.querySelector(".oc-free-gift.promo-discount").classList.remove("hide");              
                diff = this.scheduleObj.formatNumber(freeGiftPromo - meals_threshold);
                elm.innerHTML = `Spend <strong>$${diff}</strong> more to get <strong>Free Gift</strong>`;
            }else{
                cartSummary.querySelector(".free-delivery").classList.remove("hide");                
                if(freeGiftPromo != -1){
                    cartSummary.querySelector(".free-gift").classList.remove("hide");                    
                }                
                if(perDiscountPromo != -1){
                    cartSummary.querySelector(".oc-free-gift.promo-discount").classList.remove("hide");
                }
                elm.innerHTML = ``;
            }
        }else{
            if(meals_threshold < this.scheduleObj.currentZone['more_day_free_delivery']){
                diff = this.scheduleObj.formatNumber(this.scheduleObj.currentZone['more_day_free_delivery'] - meals_threshold);
                elm.innerHTML = `Spend <strong>$${diff}</strong> more to get <strong>Free Delivery</strong>`;
            }else if(meals_threshold > this.scheduleObj.currentZone['more_day_free_delivery'] && 
                perDiscountPromo != -1 &&
                meals_threshold < perDiscountPromo
            ){
                cartSummary.querySelector(".free-delivery").classList.remove("hide");                                
                diff = this.scheduleObj.formatNumber(perDiscountPromo - meals_threshold);
                elm.innerHTML = `Spend <strong>$${diff}</strong> more to get <strong>Discount Promo</strong>`;
            }else if(meals_threshold > this.scheduleObj.currentZone['more_day_free_delivery'] && 
                freeGiftPromo != -1 &&
                meals_threshold < freeGiftPromo
            ){
                cartSummary.querySelector(".free-delivery").classList.remove("hide");
                cartSummary.querySelector(".oc-free-gift.promo-discount").classList.remove("hide");
                diff = this.scheduleObj.formatNumber(freeGiftPromo - meals_threshold);
                elm.innerHTML = `Spend <strong>$${diff}</strong> more to get <strong>Free Gift</strong>`;
            }else{
                cartSummary.querySelector(".free-delivery").classList.remove("hide");                
                if(freeGiftPromo != -1){
                    cartSummary.querySelector(".free-gift").classList.remove("hide");
                }                
                if(perDiscountPromo != -1){
                    cartSummary.querySelector(".oc-free-gift.promo-discount").classList.remove("hide");
                }
                elm.innerHTML = ``;
            }
        }
    }

    bindOnSubmit(){
        let $this = this;
        let button = document.querySelector(".cta-checkout.simplify_button_cont .m-btn-checkout");
        button.addEventListener('click', function (event) {
            button.querySelector('.inner_text').classList.add('hidden');
            button.querySelector('.loading__spinner').classList.remove('hidden');
            if($this.meals_total > $this.scheduleObj.currentZone['min_delivery_amount']){
                $this.checkoutCartJson['settings']['notes'] = $this.container.querySelector("#delivery-note").value;
                $this.checkoutCartJson['settings']['promo_code'] = $this.container.querySelector("#c-promo-code").value;
                $this.clearCart().then(() => {
                    $this.submitCartItems().then(() => {
                        $this.updateCartAttributes();
                    });                
                });
            }            
        });        
    }

    renderCart(){
        let cartSummary = this.container.querySelector(".checkout_prices");
        this.container.querySelector(".meal-dates").textContent = this.fullDate + ' Week Meals';
        this.lineItemsRender();        
        this.deliveryTimeRender();

        let minOrderAmount = parseFloat(localStorage.getItem("minOrderAmount"));

        document.querySelector(".cta-checkout.simplify_button_cont .m-btn-checkout").classList.add("active");
        if(this.meals_total < minOrderAmount){
            document.querySelector(".cta-checkout.simplify_button_cont .m-btn-checkout").classList.remove("active");
        }        
                
        document.querySelector(".summ.minimal-order").classList.add("hide");
        if(parseFloat(this.meals_total) >= minOrderAmount){
            document.querySelector(".summ.minimal-order").classList.remove("hide");
        }

        this.meals_total = this.meals_total - this.scheduleObj.promoDiscountAmount;
        this.total_amount = this.total_amount - this.scheduleObj.promoDiscountAmount;

        if(this.scheduleObj.isSingleDay){
            if(this.meals_total >= this.scheduleObj.currentZone['one_day_free_delivery']){
                this.total_amount = this.total_amount - this.delivery_rate;
                this.delivery_rate = 0;
            }
        }else{
            if(this.meals_total >= this.scheduleObj.currentZone['more_day_free_delivery']){
                this.total_amount = this.total_amount - this.delivery_rate;
                this.delivery_rate = 0;
            }
        }        
            
        cartSummary.querySelector(".detailed_order_amount > .meals-total > h3").textContent = '$' + this.formatNumber(this.cartJson['meals_total']);
        if(this.delivery_rate > 0){
            cartSummary.querySelector(".detailed_order_amount > .weekly-saving > h3").textContent = '$' + this.formatNumber(this.delivery_rate);
        }else{
            cartSummary.querySelector(".detailed_order_amount > .weekly-saving > h3").textContent = 'FREE';
        }
        this.checkoutCartJson['settings']['is_delivery_free'] = this.delivery_rate == 0;
        
        cartSummary.querySelector(".detailed_order_amount > .delivery-tax > h3").textContent = '- $' + this.formatNumber(this.meals_weekly_savings);
        // cartSummary.querySelector(".total_amount > .total_amount_number").textContent = '$' + this.formatNumber(this.total_amount);
        if(this.is_saving == false){
            cartSummary.querySelector(".total_amount > .total_amount_number").textContent = '$' + this.formatNumber((this.total_amount+this.meals_weekly_savings));    
            this.container.querySelector('.saving.sum-draw input#purchase').click();
        }else{
            if(document.querySelector('body.limited-menu') == null){
                this.container.querySelector('.saving.sum-draw input#subscription').click();
            }
        }
        
        // this.subscription.checked = this.is_saving;
        // if(window.innerWidth > 480){
        //     setTimeout(function(){ 
        //         document.querySelector('.cta-checkout.simplify_button_cont .m-btn-checkout').click();
        //     }, 800);
        // }else{
        //     this.container.classList.add("active");
        // }
        
setTimeout(function(){ 
    document.querySelector('.cta-checkout.simplify_button_cont .m-btn-checkout').click();
}, 800);


                
        this.setProgressBar();
    }

    lineItemsRender(){
        let $this = this;
        let items = [];    
        let giftMealContainer = document.querySelector(".order-summary-drawer .checkout_prices .s-meals");    
        giftMealContainer.innerHTML = '';
        giftMealContainer.classList.add("hide");
        Object.keys(this.cartJson).forEach(day => {
            if(day != null && day != '' && !this.dayKeys.includes(day) && this.cartJson[day].is_active == true){
                items.push(`<p class="mandatory-text">${day} Delivery:</p>`);
                $this.cartJson[day]['lineItems'].forEach((item) => {
                    let priceHTML = `<div class="order_price_cont">
                                    <p class="actual">${item['price'] == 0 ? 'FREE' : '$' + item['price']}</p>
                                    <p class="discount ${ item['price'] == 0 ? 'hide' : '' }">$${ item['compare_at_price']}</p>
                                </div>`;
                    if($this.is_saving == false){
                        priceHTML = `<div class="order_price_cont">
                                        <p class="actual">$${item['compare_at_price']}</p>
                                    </div>`;
                    }

                    if(item.price == 0){                        
                        if(this.scheduleObj.isSingleDay){                            
                            giftMealContainer.innerHTML = `<div class="order-details otr-meal-card summary__free_gift" data-day="${this.currentDay}">
                                <div class="fg__info">
                                    <img src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/gift-icon.png?v=1729506741" alt="free gift" width="30" height="30">
                                    <p>${item.title}</p>
                                </div>
                                <div class="amount">FREE</div>
                            </div>`;
                            giftMealContainer.classList.remove("hide");
                        }else{
                            items.push(`<div class="order-details otr-meal-card summary__free_gift" data-day="${this.currentDay}">
                                <div class="fg__info">
                                    <img src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/gift-icon.png?v=1729506741" alt="free gift" width="30" height="30">
                                    <p>${item.title}</p>
                                </div>
                                <div class="amount">FREE</div>
                            </div>`);                            
                        }
                    }else{
                        items.push(`<div class="order-details otr-meal-card" data-day="${day}">
                            <div class="orders">
                                <div class="order">
                                    <img class="order_image" src="${item['image']}" alt="${item['title']}">
                                    <div class="order_info">
                                        <div class="order_name_cont">
                                            <h4>${item['title']}</h4>
                                            ${priceHTML}
                                        </div>
                                        <div class="order_amount ${ item['price'] == 0 ? 'hide' : '' }">
                                            <img data-id="${item['id']}" class="render qty can delete ${item['quantity'] == 1 ? '' : 'hide'}" data-action="delete" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/dustbin.svg?v=1725437510" alt="Delete">
                                            <img data-id="${item['id']}" class="render qty minus ${item['quantity'] == 1 ? 'hide' : ''}" data-action="minus" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/black_minus.svg?v=1725365256" alt="Minus">
                                            <p class="inpt-quantity c-meal-count" data-id="${item['id']}">${item['quantity']}</p>
                                            <img data-id="${item['id']}" class="render qty plus"data-action="plus" src="https://cdn.shopify.com/s/files/1/0651/4999/3148/files/black_plus.svg?v=1725365263" alt="Plus">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`);
                    } 
                    
                });
            }
        });     
        items.push('<p class="note-text">You will be able to choose your meals for the following weeks in the OTR portal as soon as you place your order </p>');
        items = items.join('');
        this.container.querySelector(".panel.c-lineitems").innerHTML = items;
    }

    deliveryTimeRender(){
        let $this = this;
        let items = [];
        Object.keys(this.cartJson).forEach(day => {  
            if(day != null && day != '' && !this.dayKeys.includes(day)){
                let status = false;
                if($this.scheduleObj.validDays.length == 1 && $this.scheduleObj.dayWiseTimeSlots[$this.scheduleObj.currentDay].length == 1){
                    status = true;
                }
                if(status == true){
                    items.push(`<div class="day-plan">
                            <div class="days">
                                <span>${day}s</span>
                            </div>
                            <div class="time">
                                ${$this.cartJson[day]['delivery_window']}
                            </div>
                        </div>`);
                }else{
                    items.push(`<div class="day-plan">
                            <div class="days">
                                <svg onclick="editDeliveryTime(this)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 16.6667H17.5M13.75 2.91669C14.0815 2.58517 14.5312 2.39893 15 2.39893C15.2321 2.39893 15.462 2.44465 15.6765 2.53349C15.891 2.62233 16.0858 2.75254 16.25 2.91669C16.4142 3.08085 16.5444 3.27572 16.6332 3.4902C16.722 3.70467 16.7678 3.93455 16.7678 4.16669C16.7678 4.39884 16.722 4.62871 16.6332 4.84319C16.5444 5.05766 16.4142 5.25254 16.25 5.41669L5.83333 15.8334L2.5 16.6667L3.33333 13.3334L13.75 2.91669Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></path>
                                </svg>
                                <span>${day}s</span>
                            </div>
                            <div class="time">
                                ${$this.cartJson[day]['delivery_window']}
                            </div>
                        </div>`);
                }
            }
        });             
        items = items.join('');
        this.container.querySelector(".day-plans").innerHTML = items;
    }

    onClose(){
        let $this = this;
        window.onclick = function(event) {
            if (event.target.classList.contains("overlay")) {
                $this.container.classList.remove("active");
                localStorage.setItem('slideOut', 'main');
            }
        }
    }

    formatNumber(number){
        return (Math.round(number * 100) / 100).toFixed(2);
    }

    async clearCart(){
        return fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {})
        .catch(error => {
            console.error('Error clearing cart:', error);
        });
    }

    async submitCartItems() {        
        let data = [];
        let items = this.checkoutCartJson['lineItems'];
        let settings = this.checkoutCartJson['settings'];

        var count_days_include = 0;
        const skipKeys = ['counter', 'meals_total', 'order_total', 'order_saving', 'order_tax'];
        Object.keys(this.cartJson).forEach(key => {
            if (!skipKeys.includes(key)) {
                if(this.cartJson[key].lineItems.length > 0){
                    count_days_include++;
                }
            }
        });

        if(this.is_saving && document.querySelector('body.limited-menu') == null){
            items.forEach((item) => {            
                data.push({
                    id: parseInt(item.variant_id), 
                    quantity: item.quantity, 
                    selling_plan: item.selling_plan_id,
                    properties: {
                        _slot: item.slot,
                        _date: item.plan_date,
                        _day: item.plan_name,
                        _daycount: count_days_include,
                        _subtotal: this.meals_total
                    }
                });
            });
        }else{
            if(document.querySelector('body.limited-menu')){
                items.forEach((item) => {
                    var daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                    var monthOfyear = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    
                    if(store_limitd_obj.overDate != ''){
                        var customoverDate = new Date(store_limitd_obj.overDate);
                        var get_html_date = `${daysOfWeek[customoverDate.getDay()]}, ${monthOfyear[customoverDate.getMonth()]} ${customoverDate.getDate()}`;
                    }else{
                        var customoverDate = new Date(item.plan_date);
                        var get_html_date = `${daysOfWeek[customoverDate.getDay()]}, ${monthOfyear[customoverDate.getMonth()]} ${customoverDate.getDate()}`;
                    }        
                    data.push({
                        id: parseInt(item.variant_id), 
                        quantity: item.quantity,
                        properties: {
                            _limited_menu:true,
                            Date: get_html_date,
                        }
                    });
                });
            }else{
                items.forEach((item) => {            
                    data.push({
                        id: parseInt(item.variant_id), 
                        quantity: item.quantity,
                        properties: {
                            _date: item.plan_date,
                            _day: item.plan_name,
                            Day: item.plan_name,
                            _daycount: count_days_include,
                            _subtotal: this.meals_total
                        }
                    });
                });
            }
        }
                
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: data })
        })
        .then(response => response.json())
        .then(data => {})
        .catch(error => {
            console.error('Error adding products to cart:', error);
        });
    }

    async updateCartAttributes(){
        // this.checkoutCartJson['settings']['notes'] = this.scheduleObj.deliveryNote;
        this.checkoutCartJson['settings']['notes'] = document.querySelector('.dl-note select').value;
        let settings = JSON.stringify(this.checkoutCartJson['settings']);
        console.log("settings: ", settings);
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    _settings: settings
                }
            })
        })
        .then(response => response.json())
        .then(data => {
            setWithExpiry('cartData', 3);
            //localStorage.removeItem("cartJSON");
            setTimeout(function(){
                window.location.href = "/checkout";
            }, 500);
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });
    }
}

class SearchFilter {
    constructor(data, date) {
        this.data = data;
        this.startDate = date;
        this.container = document.querySelector(".slideout-sec.add_filter");
        this.selectedFilters = [];
        this.init();
    }

    init(){
        this.filtersRender();
        this.onClose();
        this.clearAll();
        this.onSubmit();
    }

    onClose(){
        let $this = this;
        let button = this.container.querySelector("#ds__close");
        button.addEventListener('click', function (event) {
            $this.container.classList.remove("active");
        }); 
        
        window.onclick = function(event) {
            if (event.target.classList.contains("overlay")) {
                $this.container.classList.remove("active");
            }
        }
    }  

    clearAll() {
        let button = this.container.querySelector('.btns.btn--text');
        let $this = this;
        button.addEventListener('click', function (event) {
            $this.flushAll();
        }); 
    }

    flushAll(){
        let items = this.container.querySelectorAll(".add_filter__form .form-group > input");
        items.forEach((item) => {
            item.checked = false;
        });
        this.selectedFilters = [];
        this.updateFilterCount();
        this.updateResults();
        this.container.classList.remove("active");
    }

    updateFilterCount(){
        let number = document.querySelector(".food_catagory_btns.filter .filter-num");
        number.textContent = this.selectedFilters.length;
        number.classList.add("hide");
        if(this.selectedFilters.length > 0){
            number.classList.remove("hide");
        }
    }

    showHideCategory(){
        const mealCategoryContainers = document.querySelectorAll('.meal_catag_containers');
        mealCategoryContainers.forEach(container => {
            const builderMealsCont = container.querySelector('.builder_meals_cont');

            if (builderMealsCont) {
                const meals = builderMealsCont.querySelectorAll('.meal');
                const allHidden = Array.from(meals).every(meal => meal.classList.contains('hide'));

                if (allHidden) {
                    container.classList.add('hide');
                } else {
                    container.classList.remove('hide');
                }
            }
        });

    }

    updateResults(){
        let cols = document.querySelectorAll(".meal_selection_cont .meal_catag_containers");
        cols.forEach((col) => {
            col.classList.remove("hide");
        });

        let results = document.querySelectorAll(".meal_selection_cont .meal_selection .meal_catag_containers .builder_meals_cont .meal");
        let $this = this;
        results.forEach((result) => {
            result.classList.remove("hide");
            let product = JSON.parse(result.dataset.product);
            let filters = product.filters;
            let shouldShow = $this.selectedFilters.some(filter => filters.includes(filter));
            if( $this.selectedFilters.length > 0 && !shouldShow ){
                result.classList.add("hide");
            }
        });

        let items = document.querySelectorAll(".food_catagory_btns");
        items.forEach((item) => {
            if(!item.classList.contains("filter")){
                item.classList.remove("active");
            }
        });

        this.showHideCategory();
    }

    onSubmit(){        
        let button = this.container.querySelector('.btns.btn--success');
        let $this = this;        
        button.addEventListener('click', function (event) {
            let selected = [];
            let items = $this.container.querySelectorAll(".add_filter__form .form-group > input");
            items.forEach((item) => {
                if(item.checked){
                    selected.push(item.value);
                }
            });
            $this.selectedFilters = selected;
            $this.updateFilterCount();
            $this.updateResults();
            $this.container.classList.remove("active");
        });         
    }
    
    filtersRender(){
        let items = [];
        this.data.forEach((item) => {
            if(item['start_date'] == this.startDate){
                let filters = item['filters'];
                filters.forEach((col) => {
                    items.push(`<div class="form-group">
                                    <input type="checkbox" value='${col}' id="filter-${col}">
                                    <label for="filter-${col}">${col}</label>
                                </div>`);
                });                
            }            
        }); 
        items = items.join('');
        this.container.querySelector(".add_filter__form > form").innerHTML = items;
    }

}

class MealDetail {
    constructor() {
        this.container = document.querySelector(".slideout-sec.meal_details_sec");
        this.scheduleObj = null;
        this.init();
    }

    init(){
        this.bindProductsView();
        this.onClose();  
        this.onQtyChange();      
    }

    onQtyChange(){
        let $this = this;
        let qtys = this.container.querySelectorAll(".order_amount .qty");
        qtys.forEach((item) => {
            item.addEventListener('click', function(event) {                  
                event.stopPropagation();
                const target = event.target;
                const itemId = target.closest(".order_amount").querySelector(".inpt-quantity").getAttribute('data-id');

                // Check if cart exists for current date
                if($this.scheduleObj.cartJson[$this.scheduleObj.currentDate] == null){
                    $this.scheduleObj.cartJson[$this.scheduleObj.currentDate] = {"counter": 0};
                }

                if($this.scheduleObj.cartJson[$this.scheduleObj.currentDate] == null){
                    $this.scheduleObj.cartJson[$this.scheduleObj.currentDate] = {"counter": 0};
                }
                let currentWeekData = $this.scheduleObj.data.find(week => week.start_date === $this.scheduleObj.currentDate);    
                if($this.scheduleObj.cartJson[$this.scheduleObj.currentDate][$this.scheduleObj.currentDay] == null && 
                    currentWeekData.delivery_days.includes($this.scheduleObj.currentDay)
                ){
                    $this.scheduleObj.cartJson[$this.scheduleObj.currentDate][$this.scheduleObj.currentDay] = {
                        'lineItems': [], 
                        'counter': 0, 
                        'total_price': 0, 
                        'total_compare_price': 0, 
                        'savings': 0, 
                        'tax': parseFloat($this.scheduleObj.currentZone['delivery_amount']),
                        'grand_total': 0,
                        'grand_total_org': 0,
                        'is_active': false,
                        'delivery_window': $this.dayWiseTimeSlots[$this.scheduleObj.currentDay][0],
                        'full_date': $this.scheduleObj.fullDate
                    };
                }

                let lineItems = $this.scheduleObj.cartJson[$this.scheduleObj.currentDate][$this.scheduleObj.currentDay]['lineItems'];
                let item = lineItems.find(i => i.id == itemId);
                
                if(item == null){
                    let product = $this.container.dataset.product;
                    if (target.classList.contains('plus')) {
                        product = JSON.parse(product);
                        product.quantity = 1;
                        $this.scheduleObj.addOrUpdateCart(product, false);
                    }
                }else{
                    if (target.classList.contains('minus')) {
                        $this.scheduleObj.updateQuantity(itemId, -1);
                    } else if (target.classList.contains('plus')) {
                        $this.scheduleObj.updateQuantity(itemId, 1);
                    }

                    lineItems = $this.scheduleObj.cartJson[$this.scheduleObj.currentDate][$this.scheduleObj.currentDay].lineItems;
                    item = lineItems.find(i => i.id == itemId);                    
                    if(item){
                        $this.container.querySelector(".inpt-quantity").textContent = item.quantity;
                    }
                }
                
            });
        });
    }

    bindProductsView() {
        let $this = this;
        document.addEventListener('click', function(event) {
            if (event.target && event.target.matches('.builder_meals_cont .meal .meal_h2') || event.target.closest('div').matches('.builder_meals_cont .meal .meal_img_cont')) {
                let parent = event.target.closest(".builder_meals_cont .meal");
                $this.showProduct(parent.dataset.product);
            }

            if(event.target.matches('.builder_meals_cont .meal .slide-btn')){
                let parent = event.target.closest(".builder_meals_cont .meal");
                $this.showProduct(parent.dataset.product);
            }

            if (event.target && event.target.matches('.btns.btn--success.btn__atc')) {                
                $this.onAddToCart(event.target);
            }
        });
    }

    showProduct(product){
        product = JSON.parse(product);

        this.container.querySelector(".meal_detail__img-wrapper img").setAttribute("src", product['image']);    
        this.container.querySelector(".meal_information_cont .c-product-title").textContent = product['title'];
        if(product['weight'] != ''){
            this.container.querySelector(".meal_information_cont .qt").textContent = product['weight'];
        }
        this.container.querySelector(".bottom-item .c-product-title").textContent = product['title'];
        if(product['weight'] != ''){
            this.container.querySelector(".bottom-item .qt").textContent = product['weight'];
        }        
        this.container.querySelector(".meal_information_cont .meal_description").textContent = product['description'];
        this.container.querySelector(".meal_information_cont .meal_ingridients").innerHTML = '<b>Ingredients:</b> ' + product['ingridients'];
        this.container.querySelector(".meal_information_cont .meal_ntr .meal_ntr__item").innerHTML = product['calories'];
        this.container.querySelector(".meal_price .d-price").textContent = '$' + product['price'];
        this.container.querySelector(".meal_price .o-price").textContent = '$' + product['compare_at_price'];        
        this.container.querySelector(".inpt-quantity").dataset.id = product['id'];    
        this.container.classList.add("active");
        this.container.dataset.product = JSON.stringify(product);
        
        this.scheduleObj = $scheduleRenderer;        
    }

    onClose(){
        let $this = this;
        let button = this.container.querySelector("#ds__close");
        button.addEventListener('click', function (event) {
            $this.container.classList.remove("active");
        }); 
        
        window.onclick = function(event) {
            if (event.target.classList.contains("overlay")) {
                $this.container.classList.remove("active");
            }
        }
    } 
    
    onAddToCart(target){
        let parent = target.closest(".slideout-sec.meal_details_sec");
        let product = JSON.parse(parent.dataset.product);
        let quantity = parseInt(parent.querySelector(".inpt-quantity").textContent);

        if(quantity == null || quantity == undefined){
            quantity = 0;
        }
        product.quantity = quantity;
        
        this.scheduleObj.addOrUpdateCart(product, false);

        let button = this.container.querySelector("#ds__close");
        button.click();
    }
}






// ═══════════════════════════════════════════════════════════════════════════════
// OTRIncompleteWeekPopup
// Fires when customer hits ORDER NOW with some delivery days empty.
// No X button — customer must choose: add meals or proceed to checkout.
// ═══════════════════════════════════════════════════════════════════════════════
const OTRIncompleteWeekPopup = {

    _onCheckout: null,

    /**
     * show({ filledDays, emptyDays, onAddDay, onCheckout })
     *
     * filledDays  — array of day names that have meals, e.g. ['Sunday']
     * emptyDays   — array of day names with 0 meals, e.g. ['Wednesday']
     * onAddDay    — callback(targetDay) — called when customer clicks primary btn
     * onCheckout  — callback() — called when customer clicks secondary btn
     */
    show: function({ filledDays, emptyDays, onAddDay, onCheckout }) {
        this._onCheckout = onCheckout;

        // Inject popup HTML into DOM if it doesn't already exist
        if(!document.getElementById('otr-incomplete-week-popup')){
            this._injectHTML();
            this._injectCSS();
        }

        const popup    = document.getElementById('otr-incomplete-week-popup');
        const bodyText = document.getElementById('otr-popup-body-text');
        const addBtn   = document.getElementById('otr-popup-add-day');
        const checkBtn = document.getElementById('otr-popup-checkout');

        // Build readable day lists
        const filled = filledDays.join(' & ');
        const empty  = emptyDays[0]; // highlight the first empty day

        bodyText.textContent =
            'You\'ve added meals for ' + filled + ', but your ' + empty +
            ' order is empty. Add ' + empty + ' meals now so your whole week is covered.';

        addBtn.textContent = '+ Add ' + empty + ' Meals';

        popup.style.display = 'flex';

        // Primary button — switch to empty day tab
        addBtn.onclick = function() {
            popup.style.display = 'none';
            if(typeof onAddDay === 'function') onAddDay(empty);
        };

        // Secondary button — proceed to checkout anyway
        checkBtn.onclick = function() {
            popup.style.display = 'none';
            if(typeof onCheckout === 'function') onCheckout();
        };
    },

    hide: function() {
        var popup = document.getElementById('otr-incomplete-week-popup');
        if(popup) popup.style.display = 'none';
    },

    _injectHTML: function() {
        var html = `
            <div id="otr-incomplete-week-popup" class="otr-popup-overlay" style="display:none;">
                <div class="otr-popup-box">
                    <h2 class="otr-popup-headline">Your week isn't complete yet.</h2>
                    <p class="otr-popup-body" id="otr-popup-body-text"></p>
                    <button class="otr-popup-btn-primary" id="otr-popup-add-day"></button>
                    <button class="otr-popup-btn-secondary" id="otr-popup-checkout">Continue to Checkout &rarr;</button>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);
    },

    _injectCSS: function() {
        if(document.getElementById('otr-popup-styles')) return;
        var css = `
            .otr-popup-overlay {
                position: fixed;
                inset: 0;
                background: rgba(0, 0, 0, 0.55);
                z-index: 99999;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 20px;
            }
            .otr-popup-box {
                background: #fff;
                border-radius: 16px;
                padding: 32px 24px 24px;
                max-width: 420px;
                width: 100%;
                text-align: center;
                box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
            }
            .otr-popup-headline {
                font-size: 1.25rem;
                font-weight: 700;
                color: #191919;
                margin-bottom: 12px;
                line-height: 1.3;
            }
            .otr-popup-body {
                font-size: 0.95rem;
                color: rgba(0, 0, 0, 0.65);
                line-height: 1.6;
                margin-bottom: 24px;
            }
            .otr-popup-btn-primary {
                display: block;
                width: 100%;
                padding: 14px;
                background: #4CAA63;
                color: #fff;
                font-size: 1rem;
                font-weight: 600;
                border: none;
                border-radius: 10px;
                cursor: pointer;
                margin-bottom: 12px;
                transition: background 0.2s;
            }
            .otr-popup-btn-primary:hover {
                background: #3d9654;
            }
            .otr-popup-btn-secondary {
                display: block;
                width: 100%;
                padding: 13px;
                background: transparent;
                color: #191919;
                font-size: 0.95rem;
                font-weight: 500;
                border: 1.5px solid rgba(0, 0, 0, 0.2);
                border-radius: 10px;
                cursor: pointer;
                transition: border-color 0.2s;
            }
            .otr-popup-btn-secondary:hover {
                border-color: rgba(0, 0, 0, 0.45);
            }
            @media (max-width: 480px) {
                .otr-popup-box {
                    padding: 24px 16px 20px;
                }
                .otr-popup-headline {
                    font-size: 1.1rem;
                }
            }
        `;
        var style = document.createElement('style');
        style.id = 'otr-popup-styles';
        style.textContent = css;
        document.head.appendChild(style);
    }
};


// ─────────────────────────────────────────────────────────────────────────────
// Global helpers
// ─────────────────────────────────────────────────────────────────────────────

















function callYotpo(){
    if( typeof yotpo != 'undefined' && yotpoWidgetsContainer != null){
        //console.log('tabArray yotpo.initWidgets()');
        // yotpo.initWidgets();
        yotpoWidgetsContainer.initWidgets();
        setTimeout(function(){ 
            document.querySelectorAll('.yotpo-sr-bottom-line-text[aria-label="(0)"]').forEach((ele) => {
                ele.closest('.meal_rating').classList.add('hide');
            })
        }, 1000);
    }
}

function setLocalVal(ele){
    localStorage.setItem("DeliveryNotes", ele.value);
}

window.onclick = function(event) {
    if (event.target.classList.contains("overlay")) {
        $this.container.classList.remove("active");
    }
}


// Add this function to handle the browser's back button
window.addEventListener('pageshow', function(event) {
    // Check if the page is being shown from the browser's cache (back button)
    if (event.persisted) {
        // Reset the checkout button state
        const checkoutButton = document.querySelector(".m-btn-checkout");
        if (checkoutButton) {
            checkoutButton.querySelector('.inner_text')?.classList.remove('hidden');
            checkoutButton.querySelector('.loading__spinner')?.classList.add('hidden');
        }
    }
});


